import { __read, __extends, __decorate, __metadata, __awaiter, __generator } from 'tslib';
import moment from 'moment';
import { getFromContainer, MetadataStorage, registerDecorator, IsEmail, IsNotEmpty, ValidationTypes, MaxLength, MinLength, IsNumberString, IsDate, IsNumber, Length, Min, IsInt, Max } from 'class-validator';
import { ValidationMetadata } from 'class-validator/metadata/ValidationMetadata';
import { Pipe, NgModule, Injectable, Directive, ElementRef, Renderer2, Input, HostListener, Component, ViewEncapsulation, EventEmitter, ViewChild, Output, ChangeDetectorRef, ContentChildren, Optional, ViewChildren, ContentChild, TemplateRef, Self, ViewContainerRef, ComponentFactoryResolver, Inject } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { takeWhile, debounceTime as debounceTime$1, distinctUntilChanged as distinctUntilChanged$1 } from 'rxjs/operators';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { MatProgressSpinnerModule, MatRippleModule, MatHeaderRowDef, MatRowDef, MatColumnDef, MatFooterRowDef, MatTable, MatTableModule, MatCheckboxModule, MatFormFieldModule, MatInputModule, MatIconModule, MatDatepickerModule, MatNativeDateModule, MatAutocompleteModule, MatSelectModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { isEqual as isEqual$1 } from 'lodash';
import { DataSource } from '@angular/cdk/table';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { DynamicFormGroup, DynamicFormBuilder, FOREVER_INVALID_NAME } from 'ngx-dynamic-form-builder';
import { FormArray, FormGroupDirective, NgControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { takeWhile as takeWhile$1, startWith, debounceTime, distinctUntilChanged, map } from 'rxjs/internal/operators';
import { Type, classToPlain } from 'class-transformer';
import { MatIconModule as MatIconModule$1 } from '@angular/material/icon';
import { ClickOutsideModule } from 'ng-click-outside';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { MatFormFieldModule as MatFormFieldModule$1 } from '@angular/material/form-field';
import * as _isEqual from 'lodash.isequal';
import { MatButtonModule } from '@angular/material/button';
import { saveAs } from 'file-saver';
import $ from 'jquery';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DateHelper = /** @class */ (function () {
    function DateHelper() {
    }
    /**
     * @param {?} date
     * @return {?}
     */
    DateHelper.convertDateToString = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        return moment(date).format(DateHelper.DATE_FORMAT);
    };
    /**
     * @param {?} object
     * @return {?}
     */
    DateHelper.convertAllDatesInObjectToString = /**
     * @param {?} object
     * @return {?}
     */
    function (object) {
        Object
            .entries(object)
            .filter((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return !!value;
        }))
            .forEach((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            if (value instanceof Date) {
                object[key] = DateHelper.convertDateToString(value);
            }
            else if (typeof value === 'object') {
                DateHelper.convertAllDatesInObjectToString(value);
            }
        }));
    };
    DateHelper.DATE_FORMAT = 'YYYY-MM-DD';
    return DateHelper;
}());
if (false) {
    /** @type {?} */
    DateHelper.DATE_FORMAT;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 * @param {?} object
 * @return {?}
 */
function decoratorType(object) {
    return (/**
     * @return {?}
     */
    function () { return object; });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InputHelper = /** @class */ (function () {
    function InputHelper() {
    }
    /**
     * @param {?} event
     * @return {?}
     */
    InputHelper.numberInput = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return (event.charCode >= 48 && event.charCode <= 57) || this.specialChars(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InputHelper.floatNumberInput = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return (event.charCode >= 46 && event.charCode <= 57) || this.specialChars(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InputHelper.priceInput = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return this.numberInput(event) || event.charCode === 46 || this.specialChars(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InputHelper.specialChars = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return event.key.length > 1 || event.ctrlKey;
    };
    return InputHelper;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// @dynamic
var WindowHelper = /** @class */ (function () {
    function WindowHelper() {
    }
    Object.defineProperty(WindowHelper, "isMobile", {
        get: /**
         * @return {?}
         */
        function () {
            return window.innerWidth <= this.mobileBreakpoint;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowHelper, "isTablet", {
        get: /**
         * @return {?}
         */
        function () {
            return window.innerWidth <= this.tabletBreakpoint;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowHelper, "isWideTablet", {
        get: /**
         * @return {?}
         */
        function () {
            return window.innerWidth <= this.wideTabletBreakpoint;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowHelper, "isOnlyTablet", {
        get: /**
         * @return {?}
         */
        function () {
            return this.isTablet && !this.isMobile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowHelper, "isOnlyWideTablet", {
        get: /**
         * @return {?}
         */
        function () {
            return this.isWideTablet && !this.isMobile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowHelper, "windowWidth", {
        get: /**
         * @return {?}
         */
        function () {
            return window.innerWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowHelper, "isBrowserFirefox", {
        get: /**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var firefoxUserAgentName = 'Firefox';
            return navigator.userAgent.includes(firefoxUserAgentName);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowHelper, "isIOS", {
        get: /**
         * @return {?}
         */
        function () {
            return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowHelper, "isIE", {
        get: /**
         * @return {?}
         */
        function () {
            return !!navigator.platform && (navigator.appVersion.includes('MSIE') || navigator.userAgent.includes('Trident/'));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowHelper, "isSafari", {
        get: /**
         * @return {?}
         */
        function () {
            return navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
        },
        enumerable: true,
        configurable: true
    });
    WindowHelper.mobileBreakpoint = 420;
    WindowHelper.tabletBreakpoint = 768;
    WindowHelper.wideTabletBreakpoint = 1024;
    return WindowHelper;
}());
if (false) {
    /** @type {?} */
    WindowHelper.mobileBreakpoint;
    /** @type {?} */
    WindowHelper.tabletBreakpoint;
    /** @type {?} */
    WindowHelper.wideTabletBreakpoint;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} derivedCtor
 * @param {?} baseCtors
 * @return {?}
 */
function applyMixins(derivedCtor, baseCtors) {
    baseCtors.forEach((/**
     * @param {?} baseCtor
     * @return {?}
     */
    function (baseCtor) {
        // inherit realisation
        Object
            .getOwnPropertyNames(baseCtor.prototype)
            .filter((/**
         * @param {?} name
         * @return {?}
         */
        function (name) { return name !== 'constructor'; }))
            .forEach((/**
         * @param {?} name
         * @return {?}
         */
        function (name) {
            // define getters and setters
            /** @type {?} */
            var getter = baseCtor.prototype.__lookupGetter__(name);
            /** @type {?} */
            var setter = baseCtor.prototype.__lookupSetter__(name);
            if (getter) {
                derivedCtor.prototype.__defineGetter__(name, getter);
            }
            if (setter) {
                derivedCtor.prototype.__defineSetter__(name, setter);
            }
            // define properties
            if (!getter && !setter) {
                derivedCtor.prototype[name] = baseCtor.prototype[name];
            }
        }));
        // inherit class-validator decorators
        /** @type {?} */
        var metadataList = getFromContainer(MetadataStorage).getTargetValidationMetadatas(baseCtor, '');
        metadataList.forEach((/**
         * @param {?} meta
         * @return {?}
         */
        function (meta) {
            /** @type {?} */
            var args = {
                type: meta.type,
                target: derivedCtor,
                propertyName: meta.propertyName,
                constraints: meta.constraints,
                validationOptions: {
                    message: meta.message,
                    each: meta.each
                }
            };
            /** @type {?} */
            var newMetadata = new ValidationMetadata(args);
            getFromContainer(MetadataStorage).addValidationMetadata(newMetadata);
        }));
    }));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CashPipe = /** @class */ (function () {
    function CashPipe() {
    }
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    CashPipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    function (value, args) {
        /** @type {?} */
        var new_decimal;
        /** @type {?} */
        var pattern = /\.{0}(\d+)(\d{3})/;
        /** @type {?} */
        var decimalPattern = /\.\d+/;
        value = +value;
        value = value.toFixed(3).toString();
        while (pattern.test(value)) {
            value = value.replace(pattern, '$1,$2');
        }
        /** @type {?} */
        var decimal = Number('0' + value.match(decimalPattern)).toFixed(3);
        // Amount of digits after dot (min: 2, max: 3)
        /** @type {?} */
        var fractionDigits = parseFloat(decimal).toString().substr(2).length <= 2 ? 2 : 3;
        // Float decimal to 'fractionDigits'
        new_decimal = parseFloat(decimal).toFixed(fractionDigits);
        // Move decimal to string and _delete number before dot
        new_decimal = new_decimal.toString().substr(1);
        if (args && args.removeDecimal) {
            new_decimal = '';
        }
        if (Number.isNaN(+decimal)) {
            return value + ("." + '0'.repeat(fractionDigits));
        }
        return '$' + value.replace(decimalPattern, new_decimal);
    };
    CashPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'cash'
                },] }
    ];
    return CashPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SafeUrlPipe = /** @class */ (function () {
    function SafeUrlPipe(sanitizer) {
        this.sanitizer = sanitizer;
    }
    /**
     * @param {?} url
     * @return {?}
     */
    SafeUrlPipe.prototype.transform = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    };
    SafeUrlPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'safeUrl'
                },] }
    ];
    /** @nocollapse */
    SafeUrlPipe.ctorParameters = function () { return [
        { type: DomSanitizer }
    ]; };
    return SafeUrlPipe;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    SafeUrlPipe.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PipesModule = /** @class */ (function () {
    function PipesModule() {
    }
    PipesModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        CashPipe,
                        SafeUrlPipe
                    ],
                    providers: [
                        CashPipe,
                        SafeUrlPipe
                    ],
                    exports: [
                        CashPipe,
                        SafeUrlPipe
                    ]
                },] }
    ];
    return PipesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObservableComponent = /** @class */ (function () {
    function ObservableComponent() {
        this._isComponentAlive = true;
    }
    /**
     * @return {?}
     */
    ObservableComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._isComponentAlive = false;
    };
    /**
     * @return {?}
     */
    ObservableComponent.prototype._takeWhileComponentAlive = /**
     * @return {?}
     */
    function () {
        var _this = this;
        return takeWhile((/**
         * @return {?}
         */
        function () { return _this._isComponentAlive; }));
    };
    return ObservableComponent;
}());
if (false) {
    /** @type {?} */
    ObservableComponent.prototype._isComponentAlive;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SpinnerService = /** @class */ (function () {
    function SpinnerService() {
        this.spinnerStatus = new BehaviorSubject(false);
    }
    /**
     * @return {?}
     */
    SpinnerService.prototype.showSpinner = /**
     * @return {?}
     */
    function () {
        this.spinnerStatus.next(true);
    };
    /**
     * @return {?}
     */
    SpinnerService.prototype.hideSpinner = /**
     * @return {?}
     */
    function () {
        this.spinnerStatus.next(false);
    };
    Object.defineProperty(SpinnerService.prototype, "spinnerStatusObservable", {
        get: /**
         * @return {?}
         */
        function () {
            return this.spinnerStatus.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    SpinnerService.decorators = [
        { type: Injectable }
    ];
    return SpinnerService;
}());
if (false) {
    /** @type {?} */
    SpinnerService.prototype.spinnerStatus;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FixedInBlockDirective = /** @class */ (function () {
    function FixedInBlockDirective(_el, _renderer) {
        this._el = _el;
        this._renderer = _renderer;
        this.marginTopOnFixed = 0;
        this.offsetTop = 0;
        this.fixedClass = 'fixed';
        this.disableFixed = false;
    }
    /**
     * @return {?}
     */
    FixedInBlockDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._getParentEl();
        this._calculateSummaryBlockPosition();
    };
    /**
     * @return {?}
     */
    FixedInBlockDirective.prototype.checkYOffset = /**
     * @return {?}
     */
    function () {
        this._calculateSummaryBlockPosition();
    };
    /**
     * @return {?}
     */
    FixedInBlockDirective.prototype.checkResize = /**
     * @return {?}
     */
    function () {
        this._calculateSummaryBlockPosition();
    };
    /**
     * @private
     * @return {?}
     */
    FixedInBlockDirective.prototype._calculateSummaryBlockPosition = /**
     * @private
     * @return {?}
     */
    function () {
        if (this._parentEl && this._el) {
            /** @type {?} */
            var currentYPosition = window.pageYOffset - this.offsetTop;
            /** @type {?} */
            var startTopOffset = this._getStartTopOffset();
            /** @type {?} */
            var ADDITIONAL_SPACE = 3;
            // sometimes maxMargin makes parent block to grow, so I set this additional space to prevent it
            /** @type {?} */
            var maxMargin = this._parentEl.scrollHeight - this._el.nativeElement.clientHeight - this.marginTopOnFixed - ADDITIONAL_SPACE;
            if (currentYPosition <= startTopOffset - this.marginTopOnFixed || this.disableFixed) {
                this._setTopPosition();
            }
            else if (currentYPosition >= startTopOffset + maxMargin) {
                this._setBottomPosition(maxMargin);
            }
            else {
                this._setFixedPosition();
            }
        }
    };
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    FixedInBlockDirective.prototype._updateElementMarginTop = /**
     * @private
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._renderer.setStyle(this._el.nativeElement, 'margin-top', value + "px");
    };
    /**
     * @private
     * @return {?}
     */
    FixedInBlockDirective.prototype._setElementFixedClass = /**
     * @private
     * @return {?}
     */
    function () {
        this._renderer.addClass(this._el.nativeElement, this.fixedClass);
    };
    /**
     * @private
     * @return {?}
     */
    FixedInBlockDirective.prototype._removeElementFixedClass = /**
     * @private
     * @return {?}
     */
    function () {
        this._renderer.removeClass(this._el.nativeElement, this.fixedClass);
    };
    /**
     * @private
     * @return {?}
     */
    FixedInBlockDirective.prototype._getParentEl = /**
     * @private
     * @return {?}
     */
    function () {
        this._parentEl = this._el.nativeElement.parentNode;
    };
    /**
     * @private
     * @return {?}
     */
    FixedInBlockDirective.prototype._getStartTopOffset = /**
     * @private
     * @return {?}
     */
    function () {
        return this._parentEl.getBoundingClientRect().top + window.pageYOffset;
    };
    /**
     * @private
     * @return {?}
     */
    FixedInBlockDirective.prototype._setTopPosition = /**
     * @private
     * @return {?}
     */
    function () {
        this._removeElementFixedClass();
        this._setElementWidth();
        this._updateElementMarginTop(0);
    };
    /**
     * @private
     * @param {?} maxMargin
     * @return {?}
     */
    FixedInBlockDirective.prototype._setBottomPosition = /**
     * @private
     * @param {?} maxMargin
     * @return {?}
     */
    function (maxMargin) {
        this._removeElementFixedClass();
        this._setElementWidth();
        this._updateElementMarginTop(this.marginTopOnFixed + maxMargin);
    };
    /**
     * @private
     * @return {?}
     */
    FixedInBlockDirective.prototype._setFixedPosition = /**
     * @private
     * @return {?}
     */
    function () {
        this._setElementFixedClass();
        this._setElementWidth(this._parentEl.clientWidth);
        this._updateElementMarginTop(this.marginTopOnFixed);
    };
    /**
     * @private
     * @param {?=} widthValue
     * @return {?}
     */
    FixedInBlockDirective.prototype._setElementWidth = /**
     * @private
     * @param {?=} widthValue
     * @return {?}
     */
    function (widthValue) {
        if (widthValue === void 0) { widthValue = 'auto'; }
        /** @type {?} */
        var width = typeof widthValue === 'number' ? widthValue + "px" : widthValue;
        this._renderer.setStyle(this._el.nativeElement, 'width', width);
    };
    FixedInBlockDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[appFixedInBlock]',
                },] }
    ];
    /** @nocollapse */
    FixedInBlockDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    FixedInBlockDirective.propDecorators = {
        marginTopOnFixed: [{ type: Input }],
        offsetTop: [{ type: Input }],
        fixedClass: [{ type: Input }],
        disableFixed: [{ type: Input }],
        checkYOffset: [{ type: HostListener, args: ['window:scroll', ['$event'],] }],
        checkResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
    };
    return FixedInBlockDirective;
}());
if (false) {
    /** @type {?} */
    FixedInBlockDirective.prototype.marginTopOnFixed;
    /** @type {?} */
    FixedInBlockDirective.prototype.offsetTop;
    /** @type {?} */
    FixedInBlockDirective.prototype.fixedClass;
    /** @type {?} */
    FixedInBlockDirective.prototype.disableFixed;
    /**
     * @type {?}
     * @private
     */
    FixedInBlockDirective.prototype._parentEl;
    /**
     * @type {?}
     * @private
     */
    FixedInBlockDirective.prototype._el;
    /**
     * @type {?}
     * @private
     */
    FixedInBlockDirective.prototype._renderer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DirectivesModule = /** @class */ (function () {
    function DirectivesModule() {
    }
    DirectivesModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                    ],
                    declarations: [FixedInBlockDirective],
                    exports: [FixedInBlockDirective]
                },] }
    ];
    return DirectivesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ButtonColorScheme = {
    PRIMARY: 'primary',
    PRIMARY_SHADOW: 'primary-shadow',
    PRIMARY_REVERSE: 'primary-reverse',
    DEFAULT: 'default',
    GREEN: 'green',
    ORANGE: 'orange',
    GRAY: 'gray',
    DASHED: 'dashed',
    WHITE: 'white',
    RED: 'red',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ButtonType = {
    SIMPLE: 'button',
    ROUND: 'button-round',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ButtonComponent = /** @class */ (function () {
    function ButtonComponent() {
        this.type = ButtonType.SIMPLE;
        this.color = ButtonColorScheme.PRIMARY;
        this.disabled = false;
        this.showSpinner = false;
        this.shadow = false;
    }
    ButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-button',
                    template: "<div\n  matRipple\n  [matRippleDisabled]=\"disabled\"\n  [class]=\"type + ' ' + color\"\n  [ngClass]=\"{'disabled': disabled, 'shadow': shadow}\"\n>\n  <span\n    class=\"button-name\"\n    [class.hidden]=\"showSpinner\"\n  >\n    <ng-content></ng-content>\n  </span>\n  <mat-progress-spinner\n    *ngIf=\"showSpinner\"\n    [mode]=\"'indeterminate'\"\n    [diameter]=\"20\"\n    [strokeWidth]=\"3\"\n  ></mat-progress-spinner>\n</div>\n",
                    encapsulation: ViewEncapsulation.None,
                    styles: [".button{width:calc(100% - 34px);max-width:150px;padding:15px;text-align:center;border:2px solid #4a90e2;border-radius:6px;font-weight:400;cursor:pointer;outline:0;display:flex;justify-content:center;align-items:center;transition:.2s}.button:hover{opacity:.9}.button ::ng-deep mat-progress-spinner circle{stroke:#fff}.button ::ng-deep mat-icon ::ng-deep svg path{fill:#fff}.button.primary{color:#fff;background-color:#4a90e2}.button.primary-reverse{color:#4a90e2;background-color:#fff;border:none}.button.primary-reverse ::ng-deep mat-progress-spinner circle{stroke:#4a90e2}.button.primary-reverse ::ng-deep mat-icon ::ng-deep svg path{fill:#4a90e2}.button.green{color:#fff;background-color:#61cc61;border-color:#61cc61}.button.red{color:#fff;background-color:#f7443a;border-color:#f7443a}.button.orange{color:#ffac05;background-color:transparent;border-color:#ffac05}.button.orange ::ng-deep mat-progress-spinner circle{stroke:#ffac05}.button.orange ::ng-deep mat-icon ::ng-deep svg path{fill:#ffac05}.button.gray{color:#6b7c93;background-color:#f9f9f9;border-color:#9b9b9b;border-width:1px;width:calc(100% - 32px)}.button.gray ::ng-deep mat-progress-spinner circle{stroke:#6b7c93}.button.gray ::ng-deep mat-icon ::ng-deep svg path{fill:#6b7c93}.button.default{color:#4a90e2;background-color:transparent}.button.default ::ng-deep mat-progress-spinner circle{stroke:#4a90e2}.button.default ::ng-deep mat-icon ::ng-deep svg path{fill:#4a90e2}.button.right{float:right}.button.disabled{border:2px solid #e0e2e5;cursor:auto;color:#7f8fa4;background-color:transparent}.button.shadow{box-shadow:0 4px 12px 0 rgba(0,0,0,.1)}.button.shadow:hover{box-shadow:none;opacity:.9}.button.white{padding:18px 15px;width:calc(100% - 32px);background-color:#fff;color:#4a90e2;border-color:transparent;border-radius:0;border-width:1px}.button.white ::ng-deep mat-progress-spinner circle{stroke:#4a90e2}.button.white ::ng-deep mat-icon ::ng-deep svg path{fill:#4a90e2}.button.dashed{color:#4a90e2;border-color:#4a90e2;border-style:dashed}.button.dashed:hover{border-style:solid}.button.dashed ::ng-deep mat-progress-spinner circle{stroke:#4a90e2}.button.dashed ::ng-deep mat-icon ::ng-deep svg path{fill:#4a90e2}.button *+*{margin-left:5px}.button-round{padding:17px;border:2px solid #4a90e2;border-radius:100px;color:#fff;font-weight:400;cursor:pointer;outline:0;display:flex;justify-content:center;align-items:center;text-align:center;transition:opacity .2s}.button-round ::ng-deep mat-progress-spinner circle{stroke:#fff}.button-round mat-icon ::ng-deep svg path{fill:#fff}.button-round.default{border:2px solid #4a90e2;color:#4a90e2}.button-round.default ::ng-deep mat-progress-spinner circle{stroke:#4a90e2}.button-round.default mat-icon ::ng-deep svg path{fill:#4a90e2}.button-round.primary{background-color:#4a90e2}.button-round.primary:hover{opacity:.9}.button-round.disabled{border:2px solid #e0e2e5;cursor:auto;color:#7f8fa4;background-color:transparent}.button-round.primary-shadow{background-color:#4a90e2;box-shadow:0 2px 30px 0 rgba(74,144,226,.36);font-size:18px}.button-round.primary-shadow:hover{opacity:.9}.button-round.primary-reverse{color:#4a90e2;background-color:#fff;border:2px solid #4a90e2;transition:.2s}.button-round *+:not(mat-progress-spinner){margin-left:5px}@media screen and (max-width:769px){.button,.button-round{max-width:100px}}.button .button-name,.button-round .button-name{font-size:16px;width:100%;height:100%;display:flex;justify-content:center;align-items:center}.button .button-name.hidden,.button-round .button-name.hidden{position:absolute;opacity:0;visibility:hidden}"]
                }] }
    ];
    ButtonComponent.propDecorators = {
        type: [{ type: Input }],
        color: [{ type: Input }],
        disabled: [{ type: Input }],
        showSpinner: [{ type: Input }],
        shadow: [{ type: Input }]
    };
    return ButtonComponent;
}());
if (false) {
    /** @type {?} */
    ButtonComponent.prototype.type;
    /** @type {?} */
    ButtonComponent.prototype.color;
    /** @type {?} */
    ButtonComponent.prototype.disabled;
    /** @type {?} */
    ButtonComponent.prototype.showSpinner;
    /** @type {?} */
    ButtonComponent.prototype.shadow;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ButtonModule = /** @class */ (function () {
    function ButtonModule() {
    }
    ButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatProgressSpinnerModule,
                        MatRippleModule
                    ],
                    declarations: [ButtonComponent],
                    exports: [ButtonComponent]
                },] }
    ];
    return ButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CardComponent = /** @class */ (function () {
    function CardComponent() {
    }
    CardComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-card',
                    template: "<div class=\"card\">\n  <ng-content></ng-content>\n</div>\n",
                    styles: [".card{display:inline-flex;flex-direction:column;justify-content:space-between;padding:30px;min-height:170px;max-width:calc(100% - 60px);max-height:calc(100% - 60px);border:1px solid #e0e2e5;box-shadow:0 4px 12px 0 rgba(0,0,0,.1);border-radius:6px;position:relative;background-color:#fff}"]
                }] }
    ];
    return CardComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CardModule = /** @class */ (function () {
    function CardModule() {
    }
    CardModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [CardComponent],
                    exports: [CardComponent]
                },] }
    ];
    return CardModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GeneralMessage = /** @class */ (function () {
    function GeneralMessage(title, type, payload) {
        this.type = type;
        this.title = title;
        this.payload = payload;
    }
    return GeneralMessage;
}());
if (false) {
    /** @type {?} */
    GeneralMessage.prototype.type;
    /** @type {?} */
    GeneralMessage.prototype.title;
    /** @type {?} */
    GeneralMessage.prototype.payload;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var GeneralMessageType = {
    CONFIRMATION: 'CONFIRMATION',
    NOTICE: 'NOTICE',
    ERROR: 'ERROR',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MessageComponent = /** @class */ (function () {
    function MessageComponent() {
        this.removeMessage = new EventEmitter();
        this.GeneralMessageType = GeneralMessageType;
    }
    /**
     * @return {?}
     */
    MessageComponent.prototype.onRemoveMessage = /**
     * @return {?}
     */
    function () {
        this.removeMessage.emit();
    };
    Object.defineProperty(MessageComponent.prototype, "isBodyEmpty", {
        get: /**
         * @return {?}
         */
        function () {
            return this.bodyWrapper.nativeElement.children.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    MessageComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-message',
                    template: "<div class=\"message\">\n  <div\n    class=\"message-header\"\n    [ngClass]=\"{\n    'error': message.type === GeneralMessageType.ERROR,\n    'notice': message.type === GeneralMessageType.NOTICE,\n    'confirmation': message.type === GeneralMessageType.CONFIRMATION,\n    'with-body': !isBodyEmpty\n  }\"\n  >\n    <span class=\"message-title\">\n      {{ message.title }}\n    </span>\n\n    <img\n      class=\"close-icon\"\n      src=\"../../../../../assets/images/messages/cross.svg\"\n      alt=\"close-icon\"\n      (click)=\"onRemoveMessage()\"\n    >\n  </div>\n\n  <div\n    class=\"body-wrapper\"\n    #bodyWrapper\n  >\n    <ng-content\n      class=\"body\"\n    ></ng-content>\n  </div>\n</div>\n",
                    styles: [".message{display:flex;flex-direction:column;font-size:12px;box-shadow:0 4px 12px 0 rgba(0,0,0,.1);border-radius:6px}.message .message-header{width:calc(100% - 40px);padding:10px 20px;display:flex;align-self:center;justify-content:space-between;color:#fff;border-radius:6px}.message .message-header.notice{background-color:#ffac05}.message .message-header.error{background-color:#f7443a}.message .message-header.confirmation{background-color:#61cc61}.message .message-header.with-body{border-radius:6px 6px 0 0}.message .message-header .message-title{font-size:14px;margin-top:1px}.message .close-icon{opacity:1;cursor:pointer;transition:opacity .2s}.message .close-icon:hover{opacity:.7}::ng-deep .message .body-wrapper>*{color:#041317;display:block;width:calc(100% - 40px);padding:10px 20px;background-color:#fff;border-radius:0 0 6px 6px}"]
                }] }
    ];
    MessageComponent.propDecorators = {
        bodyWrapper: [{ type: ViewChild, args: ['bodyWrapper',] }],
        message: [{ type: Input }],
        removeMessage: [{ type: Output }]
    };
    return MessageComponent;
}());
if (false) {
    /** @type {?} */
    MessageComponent.prototype.bodyWrapper;
    /** @type {?} */
    MessageComponent.prototype.message;
    /** @type {?} */
    MessageComponent.prototype.removeMessage;
    /** @type {?} */
    MessageComponent.prototype.GeneralMessageType;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MessageModule = /** @class */ (function () {
    function MessageModule() {
    }
    MessageModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [MessageComponent],
                    exports: [MessageComponent]
                },] }
    ];
    return MessageModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConfirmationMessage = /** @class */ (function (_super) {
    __extends(ConfirmationMessage, _super);
    function ConfirmationMessage(title, payload) {
        if (payload === void 0) { payload = {}; }
        return _super.call(this, title, GeneralMessageType.CONFIRMATION, payload) || this;
    }
    return ConfirmationMessage;
}(GeneralMessage));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ErrorMessage = /** @class */ (function (_super) {
    __extends(ErrorMessage, _super);
    function ErrorMessage(title, payload) {
        if (payload === void 0) { payload = {}; }
        return _super.call(this, title, GeneralMessageType.ERROR, payload) || this;
    }
    return ErrorMessage;
}(GeneralMessage));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NoticeMessage = /** @class */ (function (_super) {
    __extends(NoticeMessage, _super);
    function NoticeMessage(title, payload) {
        if (payload === void 0) { payload = {}; }
        return _super.call(this, title, GeneralMessageType.NOTICE, payload) || this;
    }
    return NoticeMessage;
}(GeneralMessage));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Messages = /** @class */ (function () {
    function Messages(messages) {
        if (messages === void 0) { messages = []; }
        this.messages = messages;
    }
    Object.defineProperty(Messages.prototype, "hasErrors", {
        get: /**
         * @return {?}
         */
        function () {
            return this.messages.some((/**
             * @param {?} msg
             * @return {?}
             */
            function (msg) { return msg.type === GeneralMessageType.ERROR; }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Messages.prototype, "hasMessages", {
        get: /**
         * @return {?}
         */
        function () {
            return this.messages.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    Messages.prototype.clearMessages = /**
     * @return {?}
     */
    function () {
        this.messages = [];
    };
    /**
     * @param {?} err
     * @return {?}
     */
    Messages.prototype.setBackendErrors = /**
     * @param {?} err
     * @return {?}
     */
    function (err) {
        var _this = this;
        /** @type {?} */
        var error = err.error || err;
        if (error && typeof error === 'object') {
            /** @type {?} */
            var errorKeys = Object.keys(error);
            if (errorKeys.length === 0) {
                this.addErrorMessage('Something went wrong :(');
            }
            else {
                errorKeys.forEach((/**
                 * @param {?} key
                 * @return {?}
                 */
                function (key) {
                    /** @type {?} */
                    var keyValue = error[key];
                    if (key === Messages.BACKEND_ERROR_KEY) {
                        if (typeof keyValue === 'object' && !Array.isArray(keyValue)) {
                            _this.setBackendErrors(keyValue);
                        }
                        else {
                            _this.addErrorMessage(keyValue);
                        }
                    }
                }));
                if (this.messages.length === 0) {
                    this.addErrorMessage('Some errors have been occurred');
                }
            }
        }
        else {
            this.addErrorMessage('Something went wrong :(');
        }
    };
    /**
     * @param {?} text
     * @param {?=} payload
     * @return {?}
     */
    Messages.prototype.addErrorMessage = /**
     * @param {?} text
     * @param {?=} payload
     * @return {?}
     */
    function (text, payload) {
        if (payload === void 0) { payload = {}; }
        this.messages.push(new ErrorMessage(text, payload));
    };
    /**
     * @param {?} text
     * @param {?=} payload
     * @return {?}
     */
    Messages.prototype.addNoticeMessage = /**
     * @param {?} text
     * @param {?=} payload
     * @return {?}
     */
    function (text, payload) {
        if (payload === void 0) { payload = {}; }
        this.messages.push(new NoticeMessage(text, payload));
    };
    /**
     * @param {?} text
     * @param {?=} payload
     * @return {?}
     */
    Messages.prototype.addConfirmationMessage = /**
     * @param {?} text
     * @param {?=} payload
     * @return {?}
     */
    function (text, payload) {
        if (payload === void 0) { payload = {}; }
        this.messages.push(new ConfirmationMessage(text, payload));
    };
    /**
     * @param {?} index
     * @return {?}
     */
    Messages.prototype.removeMessage = /**
     * @param {?} index
     * @return {?}
     */
    function (index) {
        this.messages.splice(index, 1);
    };
    Messages.BACKEND_ERROR_KEY = 'detail';
    return Messages;
}());
if (false) {
    /** @type {?} */
    Messages.BACKEND_ERROR_KEY;
    /** @type {?} */
    Messages.prototype.messages;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MessageListComponent = /** @class */ (function () {
    function MessageListComponent() {
    }
    MessageListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-message-list',
                    template: "<div class=\"messages\">\n  <app-message\n    *ngFor=\"let message of messages.messages; let i = index\"\n    [message]=\"message\"\n    (removeMessage)=\"messages.removeMessage(i)\"\n  ></app-message>\n</div>\n",
                    styles: ["app-message+app-message ::ng-deep .message{margin-top:5px}"]
                }] }
    ];
    MessageListComponent.propDecorators = {
        messages: [{ type: Input }]
    };
    return MessageListComponent;
}());
if (false) {
    /** @type {?} */
    MessageListComponent.prototype.messages;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MessageListModule = /** @class */ (function () {
    function MessageListModule() {
    }
    MessageListModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MessageModule
                    ],
                    declarations: [MessageListComponent],
                    exports: [
                        MessageListComponent
                    ]
                },] }
    ];
    return MessageListModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SpinnerComponent = /** @class */ (function (_super) {
    __extends(SpinnerComponent, _super);
    function SpinnerComponent(_spinnerService) {
        var _this = _super.call(this) || this;
        _this._spinnerService = _spinnerService;
        _this.showSpinner = false;
        return _this;
    }
    /**
     * @return {?}
     */
    SpinnerComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._subscribeOnSpinnerStatus();
    };
    /**
     * @private
     * @return {?}
     */
    SpinnerComponent.prototype._subscribeOnSpinnerStatus = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this._spinnerService
            .spinnerStatusObservable
            .pipe(this._takeWhileComponentAlive())
            .subscribe((/**
         * @param {?} showSpinner
         * @return {?}
         */
        function (showSpinner) { return _this.showSpinner = showSpinner; }));
    };
    SpinnerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-spinner',
                    template: "<div\n  *ngIf=\"showSpinner\"\n  class=\"spinner-container-big\"\n>\n  <mat-progress-spinner\n    class=\"spinner\"\n    [mode]=\"'indeterminate'\"\n  >\n  </mat-progress-spinner>\n</div>\n",
                    styles: [".spinner-container-big{position:fixed;top:0;left:0;height:100vh;width:100vw;z-index:1300;background-color:rgba(255,255,255,.9);display:flex;justify-content:center;align-items:center}"]
                }] }
    ];
    /** @nocollapse */
    SpinnerComponent.ctorParameters = function () { return [
        { type: SpinnerService }
    ]; };
    return SpinnerComponent;
}(ObservableComponent));
if (false) {
    /** @type {?} */
    SpinnerComponent.prototype.showSpinner;
    /**
     * @type {?}
     * @private
     */
    SpinnerComponent.prototype._spinnerService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SpinnerModule = /** @class */ (function () {
    function SpinnerModule() {
    }
    SpinnerModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [SpinnerComponent],
                    imports: [
                        CommonModule,
                        MatProgressSpinnerModule
                    ],
                    exports: [SpinnerComponent]
                },] }
    ];
    return SpinnerModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BurgerButtonComponent = /** @class */ (function () {
    function BurgerButtonComponent() {
        this.onBurgerButtonStatusChange = new EventEmitter();
        this.showMenuItems = false;
    }
    /**
     * @return {?}
     */
    BurgerButtonComponent.prototype.toggleMenuItems = /**
     * @return {?}
     */
    function () {
        this.showMenuItems = !this.showMenuItems;
        this.onBurgerButtonStatusChange.emit(this.showMenuItems);
    };
    BurgerButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-burger-button',
                    template: "<div\n  class=\"icon-container\"\n  (click)=\"toggleMenuItems()\"\n>\n  <span\n    class=\"icon\"\n    [ngClass]=\"{'open': showMenuItems}\"\n  >\n    <span></span>\n    <span></span>\n    <span></span>\n    <span></span>\n  </span>\n</div>\n",
                    styles: [".icon-container{width:30px;height:19px}.icon-container .icon{width:30px;height:19px;position:relative;transform:rotate(0);transition:.5s ease-in-out;cursor:pointer}.icon-container .icon span{display:block;position:absolute;height:2px;width:30px;background:#041317;border-radius:9px;opacity:1;left:0;transform:rotate(0);transition:.25s ease-in-out}.icon-container .icon span:nth-child(1){top:1px}.icon-container .icon span:nth-child(2),.icon-container .icon span:nth-child(3){top:9px}.icon-container .icon span:nth-child(4){top:17px}.icon-container .icon.open span:nth-child(1){top:9px;width:0;left:50%}.icon-container .icon.open span:nth-child(2){transform:rotate(45deg)}.icon-container .icon.open span:nth-child(3){transform:rotate(-45deg)}.icon-container .icon.open span:nth-child(4){top:9px;width:0;left:50%}"]
                }] }
    ];
    BurgerButtonComponent.propDecorators = {
        onBurgerButtonStatusChange: [{ type: Output }],
        showMenuItems: [{ type: Input }]
    };
    return BurgerButtonComponent;
}());
if (false) {
    /** @type {?} */
    BurgerButtonComponent.prototype.onBurgerButtonStatusChange;
    /** @type {?} */
    BurgerButtonComponent.prototype.showMenuItems;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BurgerButtonModule = /** @class */ (function () {
    function BurgerButtonModule() {
    }
    BurgerButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        BurgerButtonComponent
                    ],
                    exports: [
                        BurgerButtonComponent
                    ]
                },] }
    ];
    return BurgerButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaginationComponent = /** @class */ (function () {
    function PaginationComponent() {
        this.ready = false;
        this.visiblePagesRange = 2;
        this.currentPageChange = new EventEmitter();
        this.currentPage = 1;
        this.WindowHelper = WindowHelper;
    }
    Object.defineProperty(PaginationComponent.prototype, "page", {
        set: /**
         * @param {?} page
         * @return {?}
         */
        function (page) {
            this.currentPage = !!page ? +page : 1;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(PaginationComponent.prototype, "totalCount", {
        get: /**
         * @return {?}
         */
        function () {
            return this._totalCount;
        },
        set: /**
         * @param {?} count
         * @return {?}
         */
        function (count) {
            if (count !== this._totalCount) {
                this._totalCount = count;
                this.buildCustomPagination(this.totalCount, this.itemsPerPage, this.currentPage);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    PaginationComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.buildCustomPagination(this.totalCount, this.itemsPerPage, this.currentPage);
    };
    /**
     * @return {?}
     */
    PaginationComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.ready = true;
    };
    Object.defineProperty(PaginationComponent.prototype, "pagination", {
        get: /**
         * @return {?}
         */
        function () {
            return this._pagination;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "paginationLinkPrev", {
        get: /**
         * @return {?}
         */
        function () {
            return this._paginationLinkPrev;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "paginationLinkNext", {
        get: /**
         * @return {?}
         */
        function () {
            return this._paginationLinkNext;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "currentItemsCountFrom", {
        get: /**
         * @return {?}
         */
        function () {
            return this._firstCurrentPageElementIndex + (this.currentPageItemsCount === 0 ? 0 : 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "currentItemsCountTo", {
        get: /**
         * @return {?}
         */
        function () {
            return this._firstCurrentPageElementIndex + this.currentPageItemsCount;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} arrayLength
     * @param {?} itemsPerPage
     * @param {?} page
     * @return {?}
     */
    PaginationComponent.prototype.buildCustomPagination = /**
     * @param {?} arrayLength
     * @param {?} itemsPerPage
     * @param {?} page
     * @return {?}
     */
    function (arrayLength, itemsPerPage, page) {
        /** @type {?} */
        var pagesCount = Math.ceil(arrayLength / itemsPerPage);
        this._pagination = Array.from({ length: pagesCount }, (/**
         * @param {?} v
         * @param {?} k
         * @return {?}
         */
        function (v, k) { return k + 1; }));
        this._paginationLinkNext = page + 1 <= this._pagination.length ? 'true' : null;
        this._paginationLinkPrev = page > 1 ? 'true' : null;
        this.currentPage = page;
    };
    /**
     * @param {?} page
     * @return {?}
     */
    PaginationComponent.prototype.setCurrentPage = /**
     * @param {?} page
     * @return {?}
     */
    function (page) {
        this.currentPage = page;
        this.currentPageChange.emit(page);
    };
    /**
     * @param {?} page
     * @param {?} avaliableToClick
     * @return {?}
     */
    PaginationComponent.prototype.paginationClick = /**
     * @param {?} page
     * @param {?} avaliableToClick
     * @return {?}
     */
    function (page, avaliableToClick) {
        if (avaliableToClick) {
            this.setCurrentPage(page);
            this.buildCustomPagination(this.totalCount, this.itemsPerPage, page);
        }
    };
    Object.defineProperty(PaginationComponent.prototype, "_firstCurrentPageElementIndex", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return (this.currentPage - 1) * this.itemsPerPage;
        },
        enumerable: true,
        configurable: true
    });
    PaginationComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-pagination',
                    template: "<div class=\"pagination-container\" *ngIf=\"pagination && pagination.length > 1\">\n  <div class=\"pagination\">\n    <span\n      *ngIf=\"ready && !WindowHelper.isMobile\"\n      class=\"pagination__tab pagination__link prev\"\n      [ngClass]=\"{'hidden': currentPage - visiblePagesRange <= 1}\"\n      (click)=\"paginationClick(1, currentPage - visiblePagesRange > 1)\"\n    >\n        1\n    </span>\n\n    <span\n      class=\"pagination__tab prev\"\n      [ngClass]=\"{'hidden': !paginationLinkPrev}\"\n      (click)=\"paginationClick(currentPage - 1, paginationLinkPrev)\"\n    >\n      <\n    </span>\n\n    <span class=\"tabs\">\n      <span\n        class=\"pagination__tab\"\n        *ngFor=\"let page of pagination\"\n        [ngClass]=\"{\n          'active': page === currentPage,\n          'hidden': !(page <= currentPage + visiblePagesRange && page >= currentPage - visiblePagesRange)\n        }\"\n        (click)=\"paginationClick(page, page <= currentPage + visiblePagesRange && page >= currentPage - visiblePagesRange)\"\n      >\n        {{ page }}\n      </span>\n    </span>\n\n    <span\n      class=\"pagination__tab next\"\n      [ngClass]=\"{'hidden': !paginationLinkNext}\"\n      (click)=\"paginationClick(currentPage + 1, paginationLinkNext)\"\n    >\n      >\n    </span>\n\n    <span\n      *ngIf=\"ready && !WindowHelper.isMobile\"\n      class=\"pagination__tab pagination__link next\"\n      [ngClass]=\"{'hidden': currentPage + visiblePagesRange >= pagination.length}\"\n      (click)=\"paginationClick(pagination.length, currentPage + visiblePagesRange < pagination.length)\"\n    >\n     {{ pagination.length }}\n    </span>\n  </div>\n\n  <div class=\"total-items\">\n\n    <span class=\"summary\">\n      {{ currentItemsCountFrom }}\n       -\n      {{ currentItemsCountTo }} of {{ totalCount }} results\n    </span>\n\n  </div>\n</div>\n",
                    styles: [".pagination-container{display:flex;flex-direction:column;justify-content:center;align-items:center;margin:40px 0 50px}.pagination-container .pagination__link{color:#4a90e2;cursor:pointer;outline:0}.pagination-container .pagination__link.prev{margin-right:30px}.pagination-container .pagination__link.next{margin-left:30px}.pagination-container .pagination__link.hidden{opacity:0}.pagination-container .pagination__tab{width:36px;height:40px;display:inline-flex;justify-content:center;align-items:center;border:1px solid #e0e2e5;border-radius:2px;font-size:14px;color:#9b9b9b;margin:0 5px;transition:.2s ease-in;cursor:pointer;outline:0}.pagination-container .pagination__tab:hover{border:1px solid #4a90e2;color:#041317}.pagination-container .pagination__tab.active{border:1px solid #4a90e2;color:#4a90e2}.pagination-container .pagination__tab.hidden{display:none}.pagination-container .total-items{margin-top:20px}"]
                }] }
    ];
    PaginationComponent.propDecorators = {
        page: [{ type: Input, args: ['page',] }],
        totalCount: [{ type: Input }],
        currentPageItemsCount: [{ type: Input }],
        itemsPerPage: [{ type: Input }],
        visiblePagesRange: [{ type: Input }],
        currentPageChange: [{ type: Output }]
    };
    return PaginationComponent;
}());
if (false) {
    /** @type {?} */
    PaginationComponent.prototype.ready;
    /** @type {?} */
    PaginationComponent.prototype.currentPageItemsCount;
    /** @type {?} */
    PaginationComponent.prototype.itemsPerPage;
    /** @type {?} */
    PaginationComponent.prototype.visiblePagesRange;
    /** @type {?} */
    PaginationComponent.prototype.currentPageChange;
    /** @type {?} */
    PaginationComponent.prototype.currentPage;
    /** @type {?} */
    PaginationComponent.prototype.WindowHelper;
    /**
     * @type {?}
     * @private
     */
    PaginationComponent.prototype._paginationLinkNext;
    /**
     * @type {?}
     * @private
     */
    PaginationComponent.prototype._paginationLinkPrev;
    /**
     * @type {?}
     * @private
     */
    PaginationComponent.prototype._pagination;
    /**
     * @type {?}
     * @private
     */
    PaginationComponent.prototype._totalCount;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaginationModule = /** @class */ (function () {
    function PaginationModule() {
    }
    PaginationModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [PaginationComponent],
                    exports: [PaginationComponent]
                },] }
    ];
    return PaginationModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProgressBarComponent = /** @class */ (function () {
    function ProgressBarComponent() {
    }
    Object.defineProperty(ProgressBarComponent.prototype, "isCompleted", {
        get: /**
         * @return {?}
         */
        function () {
            return (typeof this.isFilled === 'boolean') ? this.isFilled : this.percents === 100;
        },
        enumerable: true,
        configurable: true
    });
    ProgressBarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-progress-bar',
                    template: "<div class=\"progress-bar\">\n  <div class=\"header\">\n    <span class=\"title\">{{ title }}</span>\n    <span class=\"percents\">{{ percents }}%</span>\n  </div>\n\n  <div class=\"bar\">\n    <div\n      class=\"bar-filled\"\n      [ngClass]=\"{'completed': isCompleted}\"\n      [style.width]=\"percents + '%'\"\n    ></div>\n  </div>\n</div>\n",
                    styles: [".progress-bar{width:100%}.progress-bar .header{width:100%;display:flex;justify-content:space-between;align-items:baseline;font-size:14px;font-weight:700;margin-bottom:5px}.progress-bar .header .title{font-size:12px}.progress-bar .bar{width:100%;height:4px;border-radius:6px;background-color:#f9f9f9;position:relative}.progress-bar .bar .bar-filled{position:absolute;left:0;top:0;height:4px;border-radius:6px;background-color:#4a90e2;transition:.6s}.progress-bar .bar .bar-filled.completed{background-color:#61cc61}"]
                }] }
    ];
    ProgressBarComponent.propDecorators = {
        title: [{ type: Input }],
        percents: [{ type: Input }],
        isFilled: [{ type: Input }]
    };
    return ProgressBarComponent;
}());
if (false) {
    /** @type {?} */
    ProgressBarComponent.prototype.title;
    /** @type {?} */
    ProgressBarComponent.prototype.percents;
    /** @type {?} */
    ProgressBarComponent.prototype.isFilled;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProgressBarModule = /** @class */ (function () {
    function ProgressBarModule() {
    }
    ProgressBarModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [ProgressBarComponent],
                    exports: [ProgressBarComponent]
                },] }
    ];
    return ProgressBarModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var TableStyle = {
    BIG_TABLE: 0,
    SMALL_TABLE: 1,
};
TableStyle[TableStyle.BIG_TABLE] = 'BIG_TABLE';
TableStyle[TableStyle.SMALL_TABLE] = 'SMALL_TABLE';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ExtraColumnType = {
    CHECKBOX_COLUMN: 'checkbox_column',
    ACTIONS_COLUMN: 'actions_column',
    EXPANDED_DETAILS: 'expanded_details',
    EMPTY_TABLE: 'empty_table',
    INDEX_COLUMN: 'index_column',
    PROMO_COLUMN: 'promo_column',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var  /**
 * @template T
 */
DataSourceBase = /** @class */ (function (_super) {
    __extends(DataSourceBase, _super);
    function DataSourceBase(items) {
        var _this = _super.call(this) || this;
        _this.items = items;
        return _this;
    }
    /**
     * @return {?}
     */
    DataSourceBase.prototype.connect = /**
     * @return {?}
     */
    function () {
        return of(this.items);
    };
    /**
     * @return {?}
     */
    DataSourceBase.prototype.disconnect = /**
     * @return {?}
     */
    function () { };
    return DataSourceBase;
}(DataSource));
if (false) {
    /** @type {?} */
    DataSourceBase.prototype.items;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var  /**
 * @template T
 */
DataSourceWithExpandedColumns = /** @class */ (function (_super) {
    __extends(DataSourceWithExpandedColumns, _super);
    function DataSourceWithExpandedColumns() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    DataSourceWithExpandedColumns.prototype.connect = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var rows = [];
        this.items.forEach((/**
         * @param {?} element
         * @return {?}
         */
        function (element) { return rows.push(element, { detailRow: true, element: element }); }));
        return of(rows);
    };
    /**
     * @return {?}
     */
    DataSourceWithExpandedColumns.prototype.disconnect = /**
     * @return {?}
     */
    function () { };
    return DataSourceWithExpandedColumns;
}(DataSourceBase));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var TableComponent = /** @class */ (function () {
    function TableComponent(_changeDetectorRefs) {
        this._changeDetectorRefs = _changeDetectorRefs;
        this.allowMultiTemplateRows = false;
        this.tableStyle = TableStyle.BIG_TABLE;
        this.expandedElements = [];
        this.ExtraColumnType = ExtraColumnType;
    }
    Object.defineProperty(TableComponent.prototype, "data", {
        set: /**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            try {
                /** @type {?} */
                var constructor = this.allowMultiTemplateRows ? DataSourceWithExpandedColumns : DataSourceBase;
                this.dataSource = new constructor(data);
                this._changeDetectorRefs.detectChanges();
                this._setupTable();
            }
            catch (err) {
                console.log(err);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    TableComponent.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        this._setupTable();
    };
    Object.defineProperty(TableComponent.prototype, "isTableBig", {
        get: /**
         * @return {?}
         */
        function () {
            return this.tableStyle === TableStyle.BIG_TABLE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "isTableSmall", {
        get: /**
         * @return {?}
         */
        function () {
            return this.tableStyle === TableStyle.SMALL_TABLE;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} element
     * @return {?}
     */
    TableComponent.prototype.isElementExpanded = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        return this.allowMultiTemplateRows && !!this.expandedElements.find((/**
         * @param {?} expandedElement
         * @return {?}
         */
        function (expandedElement) { return isEqual$1(element, expandedElement); }));
    };
    /**
     * @param {?} element
     * @return {?}
     */
    TableComponent.prototype.toggleExpandedElement = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        if (this.allowMultiTemplateRows) {
            if (this.isElementExpanded(element)) {
                /** @type {?} */
                var elementIndex = this.expandedElements.findIndex((/**
                 * @param {?} expandedElement
                 * @return {?}
                 */
                function (expandedElement) { return isEqual$1(element, expandedElement); }));
                this.expandedElements.splice(elementIndex, 1);
            }
            else {
                this.expandedElements.push(element);
            }
        }
    };
    /**
     * @private
     * @return {?}
     */
    TableComponent.prototype._setupTable = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.rowDefs) {
            this.columnDefs.forEach((/**
             * @param {?} columnDef
             * @return {?}
             */
            function (columnDef) { return _this.table.addColumnDef(columnDef); }));
            this.rowDefs.forEach((/**
             * @param {?} rowDef
             * @return {?}
             */
            function (rowDef) { return _this.table.addRowDef(rowDef); }));
            this.headerRowDefs.forEach((/**
             * @param {?} headerRowDef
             * @return {?}
             */
            function (headerRowDef) { return _this.table.addHeaderRowDef(headerRowDef); }));
            this.footerDefs.forEach((/**
             * @param {?} footerRowDef
             * @return {?}
             */
            function (footerRowDef) { return _this.table.addFooterRowDef(footerRowDef); }));
            this.table.renderRows();
        }
    };
    TableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-table',
                    template: "<table\n  mat-table\n  [attr.multiTemplateDataRows]=\"allowMultiTemplateRows\"\n  [class.big-table]=\"isTableBig\"\n  [class.small-table]=\"isTableSmall\"\n  [dataSource]=\"dataSource\"\n>\n  <ng-content></ng-content>\n\n  <ng-container [matColumnDef]=\"ExtraColumnType.EMPTY_TABLE\">\n    <td mat-footer-cell *matFooterCellDef [attr.colspan]=\"columnsToDisplay?.length\">\n      No data. Table empty.\n    </td>\n  </ng-container>\n\n  <ng-container>\n    <tr mat-header-row *matHeaderRowDef=\"columnsToDisplay\"></tr>\n  </ng-container>\n\n  <ng-container *ngIf=\"dataSource?.items.length > 0\">\n    <tr\n      *matRowDef=\"let row; columns: columnsToDisplay;\"\n      mat-row\n      [attr.matRipple]=\"allowMultiTemplateRows\"\n      [class.expanded-row]=\"isElementExpanded(row)\"\n      (click)=\"toggleExpandedElement(row)\"\n    ></tr>\n  </ng-container>\n\n  <ng-container>\n    <tr\n      class=\"footer-row\"\n      [class.hidden]=\"dataSource?.items.length > 0\"\n      mat-footer-row\n      *matFooterRowDef=\"[ExtraColumnType.EMPTY_TABLE]\"\n    ></tr>\n  </ng-container>\n</table>\n",
                    styles: ["::ng-deep td.mat-cell,::ng-deep td.mat-footer-cell,::ng-deep th.mat-header-cell{vertical-align:middle;transition:.2s}tr{transition:.2s}tr.hidden{display:none}::ng-deep tr ::ng-deep td.mat-cell{border-top:1px solid #e0e2e5;border-bottom:none}::ng-deep tr.detail-row ::ng-deep td.mat-cell{border-top:none}::ng-deep td,::ng-deep th,::ng-deep tr{font-family:DecimaNovaPro,sans-serif}.footer-row{text-align:center}.footer-row td{font-size:16px;padding:40px}::ng-deep table.mat-table.big-table{width:100%;border-radius:8px;box-shadow:0 2px 30px 0 rgba(0,0,0,.05)}::ng-deep table.mat-table.big-table ::ng-deep th.mat-header-cell{padding:30px;font-size:16px;font-weight:400;color:#7f8fa4}::ng-deep table.mat-table.big-table ::ng-deep th.mat-header-cell:first-of-type{padding-left:40px}::ng-deep table.mat-table.big-table ::ng-deep td.mat-cell{padding:30px;font-size:16px}::ng-deep table.mat-table.big-table ::ng-deep td.mat-cell:first-of-type{padding-left:40px}::ng-deep table.mat-table.small-table{width:100%;border-radius:6px;border:1px solid #e0e2e5}::ng-deep table.mat-table.small-table ::ng-deep th.mat-header-cell{padding:25px;font-size:18px;font-weight:400;color:#7f8fa4}::ng-deep table.mat-table.small-table ::ng-deep th.mat-header-cell:first-of-type{padding-left:40px}::ng-deep table.mat-table.small-table ::ng-deep td.mat-cell{padding:25px;font-size:16px;border:none}::ng-deep table.mat-table.small-table ::ng-deep td.mat-cell:first-of-type{padding-left:40px}::ng-deep table.mat-table.small-table ::ng-deep tbody tr{background-color:#f9f9f9}::ng-deep table.mat-table.small-table ::ng-deep tbody tr:nth-child(2n){background-color:#f1f1f1}"]
                }] }
    ];
    /** @nocollapse */
    TableComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    TableComponent.propDecorators = {
        headerRowDefs: [{ type: ContentChildren, args: [MatHeaderRowDef,] }],
        rowDefs: [{ type: ContentChildren, args: [MatRowDef,] }],
        columnDefs: [{ type: ContentChildren, args: [MatColumnDef,] }],
        footerDefs: [{ type: ContentChildren, args: [MatFooterRowDef,] }],
        table: [{ type: ViewChild, args: [MatTable,] }],
        allowMultiTemplateRows: [{ type: Input }],
        tableStyle: [{ type: Input }],
        data: [{ type: Input, args: ['dataSource',] }],
        columnsToDisplay: [{ type: Input }]
    };
    return TableComponent;
}());
if (false) {
    /** @type {?} */
    TableComponent.prototype.headerRowDefs;
    /** @type {?} */
    TableComponent.prototype.rowDefs;
    /** @type {?} */
    TableComponent.prototype.columnDefs;
    /** @type {?} */
    TableComponent.prototype.footerDefs;
    /** @type {?} */
    TableComponent.prototype.table;
    /** @type {?} */
    TableComponent.prototype.allowMultiTemplateRows;
    /** @type {?} */
    TableComponent.prototype.tableStyle;
    /** @type {?} */
    TableComponent.prototype.columnsToDisplay;
    /** @type {?} */
    TableComponent.prototype.dataSource;
    /** @type {?} */
    TableComponent.prototype.expandedElements;
    /** @type {?} */
    TableComponent.prototype.ExtraColumnType;
    /**
     * @type {?}
     * @private
     */
    TableComponent.prototype._changeDetectorRefs;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CheckedItemsService = /** @class */ (function () {
    function CheckedItemsService() {
        this._checkedItems = new BehaviorSubject([]);
        this._checkedAllItems = new BehaviorSubject(false);
        this._lastCheckedIndex = 0;
    }
    Object.defineProperty(CheckedItemsService.prototype, "checkedItemsObservable", {
        get: /**
         * @return {?}
         */
        function () {
            return this._checkedItems.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckedItemsService.prototype, "checkedItems", {
        get: /**
         * @return {?}
         */
        function () {
            return this._checkedItems.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckedItemsService.prototype, "areCheckedAllItems", {
        get: /**
         * @return {?}
         */
        function () {
            return this._checkedAllItems.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} orderId
     * @param {?=} index
     * @return {?}
     */
    CheckedItemsService.prototype.checkItem = /**
     * @param {?} orderId
     * @param {?=} index
     * @return {?}
     */
    function (orderId, index) {
        /** @type {?} */
        var checkedProductsTemp = this._checkedItems.getValue();
        if (this.areCheckedAllItems) {
            this.setAllItemsChecked(false);
        }
        if (!checkedProductsTemp.includes(orderId)) {
            checkedProductsTemp.push(orderId);
        }
        else {
            checkedProductsTemp.splice(checkedProductsTemp.indexOf(orderId), 1);
        }
        this._checkedItems.next(checkedProductsTemp);
        this._lastCheckedIndex = index;
    };
    /**
     * @param {?} orderIndex
     * @param {?} ids
     * @return {?}
     */
    CheckedItemsService.prototype.checkManyItemsBetween = /**
     * @param {?} orderIndex
     * @param {?} ids
     * @return {?}
     */
    function (orderIndex, ids) {
        /** @type {?} */
        var checkedProductsTemp = this._checkedItems.getValue();
        /** @type {?} */
        var idsBetweenIndexes = this._getAllIdsBetweenIndexes(ids, orderIndex, this._lastCheckedIndex);
        if (idsBetweenIndexes.every((/**
         * @param {?} id
         * @return {?}
         */
        function (id) { return checkedProductsTemp.includes(id); }))) {
            idsBetweenIndexes
                .forEach((/**
             * @param {?} id
             * @return {?}
             */
            function (id) { return checkedProductsTemp.splice(checkedProductsTemp.indexOf(id), 1); }));
            this._checkedItems.next(checkedProductsTemp);
            this.setAllItemsChecked(false);
        }
        else {
            idsBetweenIndexes
                .forEach((/**
             * @param {?} id
             * @return {?}
             */
            function (id) {
                if (!checkedProductsTemp.includes(id)) {
                    checkedProductsTemp.push(id);
                }
            }));
            this._checkedItems.next(checkedProductsTemp);
        }
        this._lastCheckedIndex = orderIndex;
    };
    /**
     * @return {?}
     */
    CheckedItemsService.prototype.resetLastCheckedIndex = /**
     * @return {?}
     */
    function () {
        this._lastCheckedIndex = 0;
    };
    /**
     * @param {?} checked
     * @return {?}
     */
    CheckedItemsService.prototype.setAllItemsChecked = /**
     * @param {?} checked
     * @return {?}
     */
    function (checked) {
        this._checkedAllItems.next(checked);
    };
    /**
     * @param {?} orderIds
     * @return {?}
     */
    CheckedItemsService.prototype.checkManyItems = /**
     * @param {?} orderIds
     * @return {?}
     */
    function (orderIds) {
        /** @type {?} */
        var checkedProducts = this._checkedItems.getValue().concat(orderIds);
        this._checkedItems.next(Array.from(new Set(checkedProducts)));
    };
    /**
     * @param {?} orderIds
     * @return {?}
     */
    CheckedItemsService.prototype.uncheckManyItems = /**
     * @param {?} orderIds
     * @return {?}
     */
    function (orderIds) {
        /** @type {?} */
        var checkedProducts = this.checkedItems;
        orderIds
            .forEach((/**
         * @param {?} id
         * @return {?}
         */
        function (id) {
            /** @type {?} */
            var checkedProductIndex = checkedProducts.indexOf(id);
            if (checkedProductIndex !== -1) {
                checkedProducts.splice(checkedProductIndex, 1);
            }
        }));
        this.setAllItemsChecked(false);
        this._checkedItems.next(checkedProducts);
    };
    /**
     * @return {?}
     */
    CheckedItemsService.prototype.uncheckAllItems = /**
     * @return {?}
     */
    function () {
        this._checkedItems.next([]);
        this.setAllItemsChecked(false);
    };
    /**
     * @private
     * @param {?} ids
     * @param {?} startIndex
     * @param {?} endIndex
     * @return {?}
     */
    CheckedItemsService.prototype._getAllIdsBetweenIndexes = /**
     * @private
     * @param {?} ids
     * @param {?} startIndex
     * @param {?} endIndex
     * @return {?}
     */
    function (ids, startIndex, endIndex) {
        /** @type {?} */
        var indexesSort = [startIndex, endIndex].sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) { return a - b; }));
        /** @type {?} */
        var start = indexesSort[0];
        /** @type {?} */
        var end = indexesSort[1];
        return ids.filter((/**
         * @param {?} id
         * @param {?} index
         * @return {?}
         */
        function (id, index) { return index > start && index <= end; }));
    };
    CheckedItemsService.decorators = [
        { type: Injectable }
    ];
    return CheckedItemsService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    CheckedItemsService.prototype._checkedItems;
    /**
     * @type {?}
     * @private
     */
    CheckedItemsService.prototype._checkedAllItems;
    /**
     * @type {?}
     * @private
     */
    CheckedItemsService.prototype._lastCheckedIndex;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var ColumnWrapperAbstract = /** @class */ (function () {
    function ColumnWrapperAbstract(appTable, _cdRef) {
        this.appTable = appTable;
        this._cdRef = _cdRef;
    }
    /**
     * @return {?}
     */
    ColumnWrapperAbstract.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._defineColumn();
    };
    /**
     * @private
     * @return {?}
     */
    ColumnWrapperAbstract.prototype._defineColumn = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.appTable) {
            this._cdRef.detectChanges();
            this.columnDef.name = this.columnName;
            this.appTable.table.addColumnDef(this.columnDef);
        }
        else {
            throw new Error('This component should be used inside <fapp-table>');
        }
    };
    /** @nocollapse */
    ColumnWrapperAbstract.ctorParameters = function () { return [
        { type: TableComponent, decorators: [{ type: Optional }] },
        { type: ChangeDetectorRef }
    ]; };
    ColumnWrapperAbstract.propDecorators = {
        columnDef: [{ type: ViewChild, args: [MatColumnDef,] }]
    };
    return ColumnWrapperAbstract;
}());
if (false) {
    /** @type {?} */
    ColumnWrapperAbstract.prototype.columnDef;
    /** @type {?} */
    ColumnWrapperAbstract.prototype.columnName;
    /** @type {?} */
    ColumnWrapperAbstract.prototype.appTable;
    /**
     * @type {?}
     * @protected
     */
    ColumnWrapperAbstract.prototype._cdRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CheckboxColumnComponent = /** @class */ (function (_super) {
    __extends(CheckboxColumnComponent, _super);
    function CheckboxColumnComponent(appTable, _cdRef, _checkedItemsService) {
        var _this = _super.call(this, appTable, _cdRef) || this;
        _this.appTable = appTable;
        _this._cdRef = _cdRef;
        _this._checkedItemsService = _checkedItemsService;
        _this.ExtraColumnType = ExtraColumnType;
        _this.checkedItems = [];
        _this.areAllItemsOnThisPageSelected = false;
        // ObservableComponent
        _this._isComponentAlive = true;
        _this.columnName = _this.ExtraColumnType.CHECKBOX_COLUMN;
        return _this;
    }
    /**
     * @return {?}
     */
    CheckboxColumnComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        _super.prototype.ngOnInit.call(this);
        this._subscribeOnCheckedOrders();
    };
    /**
     * @return {?}
     */
    CheckboxColumnComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._isComponentAlive = false;
    };
    Object.defineProperty(CheckboxColumnComponent.prototype, "areAllItemsChecked", {
        get: /**
         * @return {?}
         */
        function () {
            return this._checkedItemsService.areCheckedAllItems || this.checkedItems.length === this.allListItemsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckboxColumnComponent.prototype, "checkedItemsAmount", {
        get: /**
         * @return {?}
         */
        function () {
            return this.areAllItemsChecked
                ? this.allListItemsCount
                : this.checkedItems.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} id
     * @return {?}
     */
    CheckboxColumnComponent.prototype.isItemChecked = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        return this.checkedItems.includes(id) || this.areAllItemsChecked;
    };
    /**
     * @return {?}
     */
    CheckboxColumnComponent.prototype.checkAllItemsOnThisPage = /**
     * @return {?}
     */
    function () {
        this.areAllItemsOnThisPageSelected
            ? this.cleanCheckedItemsOnThisPage()
            : this._checkedItemsService.checkManyItems(this.currentPageItemIds);
    };
    /**
     * @param {?} event
     * @param {?} id
     * @param {?} index
     * @return {?}
     */
    CheckboxColumnComponent.prototype.checkItem = /**
     * @param {?} event
     * @param {?} id
     * @param {?} index
     * @return {?}
     */
    function (event, id, index) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this._checkedItemsService.checkItem(id, index);
    };
    /**
     * @param {?} orderIndex
     * @return {?}
     */
    CheckboxColumnComponent.prototype.checkManyItemsBetween = /**
     * @param {?} orderIndex
     * @return {?}
     */
    function (orderIndex) {
        this._checkedItemsService.checkManyItemsBetween(orderIndex, this.currentPageItemIds);
    };
    /**
     * @return {?}
     */
    CheckboxColumnComponent.prototype.cleanCheckedItemsOnThisPage = /**
     * @return {?}
     */
    function () {
        this._checkedItemsService.resetLastCheckedIndex();
        this._checkedItemsService.uncheckManyItems(this.currentPageItemIds);
    };
    /**
     * @return {?}
     */
    CheckboxColumnComponent.prototype.cleanAllCheckedItems = /**
     * @return {?}
     */
    function () {
        this._checkedItemsService.uncheckAllItems();
    };
    /**
     * @return {?}
     */
    CheckboxColumnComponent.prototype.checkAllItems = /**
     * @return {?}
     */
    function () {
        this._checkedItemsService.setAllItemsChecked(true);
    };
    /**
     * @private
     * @return {?}
     */
    CheckboxColumnComponent.prototype._subscribeOnCheckedOrders = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this._checkedItemsService
            .checkedItemsObservable
            .pipe(this._takeWhileComponentAlive())
            .subscribe((/**
         * @param {?} checkedOrders
         * @return {?}
         */
        function (checkedOrders) {
            _this.checkedItems = checkedOrders;
            _this.areAllItemsOnThisPageSelected = _this.currentPageItemIds.every((/**
             * @param {?} id
             * @return {?}
             */
            function (id) { return _this.checkedItems.includes(id); }));
        }));
    };
    /**
     * @private
     * @return {?}
     */
    CheckboxColumnComponent.prototype._takeWhileComponentAlive = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        return takeWhile((/**
         * @return {?}
         */
        function () { return _this._isComponentAlive; }));
    };
    CheckboxColumnComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-checkbox-column',
                    template: "<ng-container [matColumnDef]=\"columnName\">\n  <th mat-header-cell *matHeaderCellDef>\n    <div class=\"main-checkbox-container\">\n      <mat-checkbox\n        [checked]=\"areAllItemsOnThisPageSelected || areAllItemsChecked\"\n        (change)=\"checkAllItemsOnThisPage()\"\n      ></mat-checkbox>\n\n      <app-card\n        *ngIf=\"checkedItems.length || areAllItemsChecked\"\n      >\n        <div>\n          {{ checkedItemsAmount }} {{ itemNamePlural }} selected\n          <b\n            *ngIf=\"!areAllItemsChecked\"\n            class=\"link\"\n            (click)=\"checkAllItems()\"\n          >\n            Select all {{ allListItemsCount }}\n          </b>\n        </div>\n      </app-card>\n    </div>\n  </th>\n\n  <td mat-cell *matCellDef=\"let item; let i = index\">\n    <mat-checkbox\n      [checked]=\"isItemChecked(item.id)\"\n      (click)=\"checkItem($event, item.id, i)\"\n    ></mat-checkbox>\n  </td>\n</ng-container>\n",
                    styles: [".main-checkbox-container{width:100%;position:relative}.main-checkbox-container app-card{position:absolute;left:35px;top:-10px;z-index:2;text-transform:none}.main-checkbox-container app-card ::ng-deep .card{min-height:0;flex-direction:row;padding:10px;white-space:nowrap;max-width:calc(100% - 20px)}"]
                }] }
    ];
    /** @nocollapse */
    CheckboxColumnComponent.ctorParameters = function () { return [
        { type: TableComponent, decorators: [{ type: Optional }] },
        { type: ChangeDetectorRef },
        { type: CheckedItemsService }
    ]; };
    CheckboxColumnComponent.propDecorators = {
        allListItemsCount: [{ type: Input }],
        currentPageItemIds: [{ type: Input }],
        itemNamePlural: [{ type: Input }]
    };
    return CheckboxColumnComponent;
}(ColumnWrapperAbstract));
if (false) {
    /** @type {?} */
    CheckboxColumnComponent.prototype.ExtraColumnType;
    /** @type {?} */
    CheckboxColumnComponent.prototype.allListItemsCount;
    /** @type {?} */
    CheckboxColumnComponent.prototype.currentPageItemIds;
    /** @type {?} */
    CheckboxColumnComponent.prototype.itemNamePlural;
    /** @type {?} */
    CheckboxColumnComponent.prototype.checkedItems;
    /** @type {?} */
    CheckboxColumnComponent.prototype.areAllItemsOnThisPageSelected;
    /** @type {?} */
    CheckboxColumnComponent.prototype._isComponentAlive;
    /** @type {?} */
    CheckboxColumnComponent.prototype.columnName;
    /** @type {?} */
    CheckboxColumnComponent.prototype.appTable;
    /**
     * @type {?}
     * @protected
     */
    CheckboxColumnComponent.prototype._cdRef;
    /**
     * @type {?}
     * @private
     */
    CheckboxColumnComponent.prototype._checkedItemsService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ExpandedRowComponent = /** @class */ (function (_super) {
    __extends(ExpandedRowComponent, _super);
    function ExpandedRowComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ExtraColumnType = ExtraColumnType;
        _this.columnName = _this.ExtraColumnType.EXPANDED_DETAILS;
        _this.isExpansionDetailRow = (/**
         * @param {?} i
         * @param {?} row
         * @return {?}
         */
        function (i, row) {
            return row.hasOwnProperty('detailRow');
        });
        return _this;
    }
    /**
     * @return {?}
     */
    ExpandedRowComponent.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        this._setupRows();
    };
    /**
     * @param {?} element
     * @return {?}
     */
    ExpandedRowComponent.prototype.isElementExpanded = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        return this.appTable.isElementExpanded(element);
    };
    /**
     * @private
     * @return {?}
     */
    ExpandedRowComponent.prototype._setupRows = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this._cdRef.detectChanges();
        this.rowDefs.forEach((/**
         * @param {?} row
         * @return {?}
         */
        function (row) { return _this.appTable.table.addRowDef(row); }));
        this.columnDefs.forEach((/**
         * @param {?} column
         * @return {?}
         */
        function (column) { return _this.appTable.table.addColumnDef(column); }));
        this.appTable.table.renderRows();
    };
    ExpandedRowComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-expanded-row',
                    template: "<ng-container\n  *matRowDef=\"let row; columns: [columnName]; when: isExpansionDetailRow\"\n>\n  <tr\n    mat-row\n    class=\"detail-row\"\n    [class.expanded-details]=\"isElementExpanded(row.element)\"\n    [@detailExpand]=\"isElementExpanded(row.element) ? 'expanded' : 'collapsed'\"\n  ></tr>\n</ng-container>\n\n<ng-container [matColumnDef]=\"columnName\">\n  <ng-container\n    *matCellDef=\"let row\"\n  >\n    <ng-template\n      [ngTemplateOutlet]=\"templateRef\"\n      [ngTemplateOutletContext]=\"{$implicit: row.element}\"\n    ></ng-template>\n  </ng-container>\n</ng-container>\n",
                    animations: [
                        trigger('detailExpand', [
                            state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden', display: 'none' })),
                            state('expanded', style({ height: '*', visibility: 'visible' })),
                            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                        ]),
                    ],
                    styles: [".detail-row{height:0;border:none;background-color:transparent}.detail-row ::ng-deep td.mat-cell{padding:0!important}.detail-row.expanded-details{height:auto}.detail-row.expanded-details ::ng-deep td.mat-cell{padding:30px 40px!important;font-size:16px}.detail-row.expanded-details ::ng-deep td.mat-cell:first-of-type{padding-left:40px}"]
                }] }
    ];
    ExpandedRowComponent.propDecorators = {
        rowDefs: [{ type: ViewChildren, args: [MatRowDef,] }],
        columnDefs: [{ type: ViewChildren, args: [MatColumnDef,] }],
        templateRef: [{ type: ContentChild, args: [TemplateRef,] }]
    };
    return ExpandedRowComponent;
}(ColumnWrapperAbstract));
if (false) {
    /** @type {?} */
    ExpandedRowComponent.prototype.ExtraColumnType;
    /** @type {?} */
    ExpandedRowComponent.prototype.rowDefs;
    /** @type {?} */
    ExpandedRowComponent.prototype.columnDefs;
    /** @type {?} */
    ExpandedRowComponent.prototype.templateRef;
    /** @type {?} */
    ExpandedRowComponent.prototype.columnName;
    /** @type {?} */
    ExpandedRowComponent.prototype.isExpansionDetailRow;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IndexColumnComponent = /** @class */ (function (_super) {
    __extends(IndexColumnComponent, _super);
    function IndexColumnComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ExtraColumnType = ExtraColumnType;
        _this.columnName = _this.ExtraColumnType.INDEX_COLUMN;
        return _this;
    }
    IndexColumnComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-index-column',
                    template: "<ng-container [matColumnDef]=\"columnName\">\n  <th mat-header-cell *matHeaderCellDef>\n    #\n  </th>\n\n  <td mat-cell *matCellDef=\"let item; let i = index\">\n    {{ i + 1 }}\n  </td>\n</ng-container>\n",
                    styles: [""]
                }] }
    ];
    return IndexColumnComponent;
}(ColumnWrapperAbstract));
if (false) {
    /** @type {?} */
    IndexColumnComponent.prototype.ExtraColumnType;
    /** @type {?} */
    IndexColumnComponent.prototype.columnName;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TableModule = /** @class */ (function () {
    function TableModule() {
    }
    TableModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [TableComponent, CheckboxColumnComponent, ExpandedRowComponent, IndexColumnComponent],
                    exports: [TableComponent, CheckboxColumnComponent, ExpandedRowComponent, IndexColumnComponent, MatTableModule],
                    imports: [
                        CommonModule,
                        MatTableModule,
                        MatCheckboxModule,
                        MatRippleModule,
                        CardModule
                    ]
                },] }
    ];
    return TableModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 * @template T
 */
function TableContainerComponentAbstract() { }
if (false) {
    /** @type {?} */
    TableContainerComponentAbstract.prototype.tableData;
    /** @type {?} */
    TableContainerComponentAbstract.prototype.columnsToDisplay;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BackButtonComponent = /** @class */ (function () {
    function BackButtonComponent(location) {
        this.location = location;
        this.disable = false;
    }
    /**
     * @return {?}
     */
    BackButtonComponent.prototype.backClicked = /**
     * @return {?}
     */
    function () {
        if (!this.disable) {
            this.location.back();
        }
    };
    BackButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-back-button',
                    template: "<a\n  class=\"get-back\"\n  (click)=\"backClicked()\"\n>\n  <img src=\"../../../../../assets/images/return-arrow.svg\" alt=\"return-arrow\">\n  <span>Back</span>\n</a>\n",
                    styles: [".get-back{margin-top:23px;font-size:14px;display:inline-flex;align-items:center;cursor:pointer;outline:0;margin-bottom:40px}.get-back span{margin:-3px 0 0 8px}@media screen and (max-width:768px){.get-back{margin-top:0;font-size:20px}.get-back img{height:15px}}"]
                }] }
    ];
    /** @nocollapse */
    BackButtonComponent.ctorParameters = function () { return [
        { type: Location }
    ]; };
    BackButtonComponent.propDecorators = {
        disable: [{ type: Input }]
    };
    return BackButtonComponent;
}());
if (false) {
    /** @type {?} */
    BackButtonComponent.prototype.disable;
    /**
     * @type {?}
     * @private
     */
    BackButtonComponent.prototype.location;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BackButtonModule = /** @class */ (function () {
    function BackButtonModule() {
    }
    BackButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [BackButtonComponent],
                    exports: [BackButtonComponent]
                },] }
    ];
    return BackButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} property
 * @param {?=} validationOptions
 * @return {?}
 */
function IsBiggerThan(property, validationOptions) {
    if (validationOptions === void 0) { validationOptions = {}; }
    /** @type {?} */
    var options = Object.assign({
        message: 'This field should be bigger than \'$constraint1\' field'
    }, validationOptions);
    return (/**
     * @param {?} object
     * @param {?} propertyName
     * @return {?}
     */
    function (object, propertyName) {
        registerDecorator({
            name: 'isBiggerThan',
            target: object.constructor,
            propertyName: propertyName,
            constraints: [property],
            options: options,
            validator: {
                validate: /**
                 * @param {?} value
                 * @param {?} args
                 * @return {?}
                 */
                function (value, args) {
                    var _a = __read(args.constraints, 1), relatedPropertyName = _a[0];
                    /** @type {?} */
                    var relatedValue = ((/** @type {?} */ (args.object)))[relatedPropertyName];
                    return typeof +value === 'number' && typeof +relatedValue === 'number'
                        ? +value >= +relatedValue
                        : true;
                }
            }
        });
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} property
 * @param {?=} validationOptions
 * @return {?}
 */
function IsSmallerThan(property, validationOptions) {
    if (validationOptions === void 0) { validationOptions = {}; }
    /** @type {?} */
    var options = Object.assign({
        message: 'This field should be smaller than \'$constraint1\' field'
    }, validationOptions);
    return (/**
     * @param {?} object
     * @param {?} propertyName
     * @return {?}
     */
    function (object, propertyName) {
        registerDecorator({
            name: 'isSmallerThan',
            target: object.constructor,
            propertyName: propertyName,
            constraints: [property],
            options: options,
            validator: {
                validate: /**
                 * @param {?} value
                 * @param {?} args
                 * @return {?}
                 */
                function (value, args) {
                    var _a = __read(args.constraints, 1), relatedPropertyName = _a[0];
                    /** @type {?} */
                    var relatedValue = ((/** @type {?} */ (args.object)))[relatedPropertyName];
                    return typeof +value === 'number' && typeof +relatedValue === 'number'
                        ? +value <= +relatedValue
                        : true;
                }
            }
        });
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} property
 * @param {?=} validationOptions
 * @return {?}
 */
function MatchField(property, validationOptions) {
    if (validationOptions === void 0) { validationOptions = {}; }
    /** @type {?} */
    var options = Object.assign({
        message: 'This field should be equal to \'$constraint1\' field'
    }, validationOptions);
    return (/**
     * @param {?} object
     * @param {?} propertyName
     * @return {?}
     */
    function (object, propertyName) {
        registerDecorator({
            name: 'matchField',
            target: object.constructor,
            propertyName: propertyName,
            constraints: [property],
            options: options,
            validator: {
                validate: /**
                 * @param {?} value
                 * @param {?} args
                 * @return {?}
                 */
                function (value, args) {
                    var _a = __read(args.constraints, 1), relatedPropertyName = _a[0];
                    /** @type {?} */
                    var relatedValue = ((/** @type {?} */ (args.object)))[relatedPropertyName];
                    return typeof value === 'string' &&
                        typeof relatedValue === 'string' &&
                        value === relatedValue;
                }
            }
        });
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?=} emailOptions
 * @param {?=} validationOptions
 * @return {?}
 */
function MyIsEmail(emailOptions, validationOptions) {
    if (emailOptions === void 0) { emailOptions = {}; }
    if (validationOptions === void 0) { validationOptions = {}; }
    /** @type {?} */
    var options = Object.assign({ message: 'Invalid email' }, validationOptions);
    return IsEmail(emailOptions, options);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?=} validationOptions
 * @return {?}
 */
function MyIsNotEmpty(validationOptions) {
    if (validationOptions === void 0) { validationOptions = {}; }
    /** @type {?} */
    var options = Object.assign({ message: 'This field should not be empty' }, validationOptions);
    return IsNotEmpty(options);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?=} validationOptions
 * @return {?}
 */
function MyIsOptional(validationOptions) {
    return (/**
     * @param {?} object
     * @param {?} propertyName
     * @return {?}
     */
    function (object, propertyName) {
        /** @type {?} */
        var args = {
            type: ValidationTypes.CONDITIONAL_VALIDATION,
            target: object.constructor,
            propertyName: propertyName,
            constraints: [(/**
                 * @param {?} obj
                 * @param {?} value
                 * @return {?}
                 */
                function (obj, value) {
                    return obj[propertyName] !== null && obj[propertyName] !== undefined && obj[propertyName] !== '';
                })],
            validationOptions: validationOptions
        };
        getFromContainer(MetadataStorage).addValidationMetadata(new ValidationMetadata(args));
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} max
 * @param {?=} validationOptions
 * @return {?}
 */
function MyMaxLength(max, validationOptions) {
    if (validationOptions === void 0) { validationOptions = {}; }
    /** @type {?} */
    var options = Object.assign({ message: "Maximum length is " + max + " symbols" }, validationOptions);
    return MaxLength(max, options);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} max
 * @param {?=} validationOptions
 * @return {?}
 */
function MyMinLength(max, validationOptions) {
    if (validationOptions === void 0) { validationOptions = {}; }
    /** @type {?} */
    var options = Object.assign({ message: "Minimum length is " + max + " symbols" }, validationOptions);
    return MinLength(max, options);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?=} validationOptions
 * @return {?}
 */
function MyIsNumberString(validationOptions) {
    if (validationOptions === void 0) { validationOptions = {}; }
    /** @type {?} */
    var options = Object.assign({ message: "This field should be a number" }, validationOptions);
    return IsNumberString(options);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?=} validationOptions
 * @return {?}
 */
function MyIsDate(validationOptions) {
    if (validationOptions === void 0) { validationOptions = {}; }
    /** @type {?} */
    var options = Object.assign({ message: 'Invalid date' }, validationOptions);
    return IsDate(options);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?=} numberOptions
 * @param {?=} validationOptions
 * @return {?}
 */
function MyIsNumber(numberOptions, validationOptions) {
    if (numberOptions === void 0) { numberOptions = {}; }
    if (validationOptions === void 0) { validationOptions = {}; }
    /** @type {?} */
    var options = Object.assign({ message: 'Invalid number' }, validationOptions);
    return IsNumber(numberOptions, options);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} min
 * @param {?=} max
 * @param {?=} validationOptions
 * @return {?}
 */
function MyLength(min, max, validationOptions) {
    if (max === void 0) { max = undefined; }
    if (validationOptions === void 0) { validationOptions = {}; }
    /** @type {?} */
    var options = Object.assign({ message: "Length should be " + min + (max ? '-' + max : '') }, validationOptions);
    return Length(min, max, options);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} min
 * @param {?=} validationOptions
 * @return {?}
 */
function MyMin(min, validationOptions) {
    if (validationOptions === void 0) { validationOptions = {}; }
    /** @type {?} */
    var options = Object.assign({ message: "Should be greater than " + min }, validationOptions);
    return Min(min, options);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?=} minDate
 * @param {?=} validationOptions
 * @return {?}
 */
function MyMinDate(minDate, validationOptions) {
    if (minDate === void 0) { minDate = new Date(); }
    minDate.setDate(minDate.getDate() - 1);
    /** @type {?} */
    var options = Object.assign({ message: "Date should be after " + moment(minDate).format('ll') }, validationOptions);
    return (/**
     * @param {?} object
     * @param {?} propertyName
     * @return {?}
     */
    function (object, propertyName) {
        registerDecorator({
            name: 'myMinDate',
            target: object.constructor,
            propertyName: propertyName,
            constraints: [minDate],
            options: options,
            validator: {
                validate: /**
                 * @param {?} value
                 * @param {?} args
                 * @return {?}
                 */
                function (value, args) {
                    var _a = __read(args.constraints, 1), _minDate = _a[0];
                    /** @type {?} */
                    var propDate = new Date(value);
                    return propDate.getTime() > new Date(_minDate).getTime();
                }
            }
        });
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?=} validationOptions
 * @return {?}
 */
function MyIsInt(validationOptions) {
    if (validationOptions === void 0) { validationOptions = {}; }
    /** @type {?} */
    var options = Object.assign({ message: 'Must be an integer' }, validationOptions);
    return IsInt(options);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} max
 * @param {?=} validationOptions
 * @return {?}
 */
function MyMax(max, validationOptions) {
    if (validationOptions === void 0) { validationOptions = {}; }
    /** @type {?} */
    var options = Object.assign({ message: "Should be smaller than " + max }, validationOptions);
    return Max(max, options);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmailForm = /** @class */ (function () {
    function EmailForm() {
        this.email = '';
    }
    __decorate([
        MyIsEmail(),
        MyIsNotEmpty(),
        __metadata("design:type", Object)
    ], EmailForm.prototype, "email", void 0);
    return EmailForm;
}());
if (false) {
    /** @type {?} */
    EmailForm.prototype.email;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var FormComponent = /** @class */ (function () {
    function FormComponent() {
        this.onBlur = new EventEmitter();
        this.onSubmit = new EventEmitter();
        this.onError = new EventEmitter();
    }
    /**
     * @return {?}
     */
    FormComponent.prototype.emitValue = /**
     * @return {?}
     */
    function () {
        this.onBlur.emit(this.form.object);
    };
    /**
     * @return {?}
     */
    FormComponent.prototype.submit = /**
     * @return {?}
     */
    function () {
        this.onSubmit.emit(this.form.object);
    };
    /**
     * @param {?} err
     * @return {?}
     */
    FormComponent.prototype.emitError = /**
     * @param {?} err
     * @return {?}
     */
    function (err) {
        this.onError.emit(err);
    };
    FormComponent.propDecorators = {
        form: [{ type: Input }],
        onBlur: [{ type: Output }],
        onSubmit: [{ type: Output }],
        onError: [{ type: Output }]
    };
    return FormComponent;
}());
if (false) {
    /** @type {?} */
    FormComponent.prototype.form;
    /** @type {?} */
    FormComponent.prototype.onBlur;
    /** @type {?} */
    FormComponent.prototype.onSubmit;
    /** @type {?} */
    FormComponent.prototype.onError;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmailFormComponent = /** @class */ (function (_super) {
    __extends(EmailFormComponent, _super);
    function EmailFormComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.placeholder = 'Email';
        return _this;
    }
    EmailFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-email-form',
                    template: "<form\n  *ngIf=\"form\"\n  [formGroup]=\"form\"\n>\n  <mat-form-field>\n    <input\n      type=\"email\"\n      matInput\n      [placeholder]=\"placeholder + ' *'\"\n      formControlName=\"email\"\n      appFormControl\n      (blur)=\"emitValue()\"\n      (keydown.enter)=\"submit()\"\n    >\n  </mat-form-field>\n</form>\n",
                    styles: ["form,form mat-form-field{width:100%}"]
                }] }
    ];
    EmailFormComponent.propDecorators = {
        placeholder: [{ type: Input }]
    };
    return EmailFormComponent;
}(FormComponent));
if (false) {
    /** @type {?} */
    EmailFormComponent.prototype.placeholder;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
;
var AppFormDirective = /** @class */ (function (_super) {
    __extends(AppFormDirective, _super);
    function AppFormDirective(_parent) {
        var _this = _super.call(this) || this;
        _this._parent = _parent;
        return _this;
    }
    /**
     * @return {?}
     */
    AppFormDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        if (!this._parent) {
            throw new Error('appForm directive should be applied to element with FormGroupDirective');
        }
        if (this.errors === null) {
            throw new Error('Pass BehaviorSubject<IValidationErrors> into appForm');
        }
        this._form = (/** @type {?} */ (this._parent.form));
        this._subscribeOnErrors();
    };
    /**
     * @private
     * @param {?} errors
     * @param {?=} form
     * @return {?}
     */
    AppFormDirective.prototype._updateErrorsBinding = /**
     * @private
     * @param {?} errors
     * @param {?=} form
     * @return {?}
     */
    function (errors, form) {
        var _this = this;
        if (form === void 0) { form = this._form; }
        // need setTimeout because it takes time to generate errorsComponentRef
        setTimeout((/**
         * @return {?}
         */
        function () {
            Object
                .entries(form.controls)
                .forEach((/**
             * @param {?} __0
             * @return {?}
             */
            function (_a) {
                var _b = __read(_a, 2), key = _b[0], control = _b[1];
                /** @type {?} */
                var errorsArray = errors[key] || [];
                if (control instanceof DynamicFormGroup) {
                    _this._updateErrorsBinding(errorsArray, control);
                }
                else if (control instanceof FormArray && errorsArray.length > 0) {
                    control.controls
                        .forEach((/**
                     * @param {?} arrayControl
                     * @param {?} index
                     * @return {?}
                     */
                    function (arrayControl, index) { return _this._updateErrorsBinding(errorsArray[index], (/** @type {?} */ (arrayControl))); }));
                }
                else if (control.hasOwnProperty('errorsComponentRef')) {
                    /** @type {?} */
                    var component = control['errorsComponentRef'];
                    component.instance.controlErrors = errorsArray;
                    control.setErrors(errorsArray);
                }
            }));
        }));
    };
    /**
     * @private
     * @return {?}
     */
    AppFormDirective.prototype._subscribeOnErrors = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.errors
            .pipe(this._takeWhileComponentAlive())
            .subscribe((/**
         * @param {?} errors
         * @return {?}
         */
        function (errors) { return _this._updateErrorsBinding(errors); }));
    };
    AppFormDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[appForm]'
                },] }
    ];
    /** @nocollapse */
    AppFormDirective.ctorParameters = function () { return [
        { type: FormGroupDirective }
    ]; };
    AppFormDirective.propDecorators = {
        errors: [{ type: Input, args: ['appForm',] }]
    };
    return AppFormDirective;
}(ObservableComponent));
if (false) {
    /** @type {?} */
    AppFormDirective.prototype.errors;
    /**
     * @type {?}
     * @private
     */
    AppFormDirective.prototype._form;
    /**
     * @type {?}
     * @private
     */
    AppFormDirective.prototype._parent;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AppErrorsComponent = /** @class */ (function () {
    function AppErrorsComponent() {
    }
    Object.defineProperty(AppErrorsComponent.prototype, "error", {
        get: /**
         * @return {?}
         */
        function () {
            return this.controlErrors ? this.controlErrors[0] : null;
        },
        enumerable: true,
        configurable: true
    });
    AppErrorsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-errors',
                    template: "\n    <mat-error *ngIf=\"!!control && control.invalid && control.touched\">\n      {{error}}\n    </mat-error>\n  ",
                    styles: ["\n    :host {\n      position: absolute;\n      width: 100%;\n      left: 0;\n      text-align: left;\n      margin-top: 2px;\n      top: 100%;\n    }\n\n    mat-error {\n      font-size: 0.8em;\n    }\n  "]
                }] }
    ];
    AppErrorsComponent.propDecorators = {
        control: [{ type: Input }],
        controlErrors: [{ type: Input }]
    };
    return AppErrorsComponent;
}());
if (false) {
    /** @type {?} */
    AppErrorsComponent.prototype.control;
    /** @type {?} */
    AppErrorsComponent.prototype.controlErrors;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AppFormControlDirective = /** @class */ (function () {
    function AppFormControlDirective(control, vcr, resolver) {
        this.control = control;
        this.vcr = vcr;
        this.resolver = resolver;
    }
    /**
     * @return {?}
     */
    AppFormControlDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var control = this.explicitControl ? this.explicitControl : this.control.control;
        /** @type {?} */
        var factory = this.resolver.resolveComponentFactory(AppErrorsComponent);
        /** @type {?} */
        var component;
        setTimeout((/**
         * @return {?}
         */
        function () {
            component = _this.vcr.createComponent(factory);
            component.instance.control = control;
            control['errorsComponentRef'] = component;
            control['parentElementRef'] = _this.vcr.element.nativeElement.parentElement;
        }), 0);
    };
    AppFormControlDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[appFormControl]',
                },] }
    ];
    /** @nocollapse */
    AppFormControlDirective.ctorParameters = function () { return [
        { type: NgControl, decorators: [{ type: Optional }, { type: Self }] },
        { type: ViewContainerRef },
        { type: ComponentFactoryResolver }
    ]; };
    AppFormControlDirective.propDecorators = {
        explicitControl: [{ type: Input, args: ['appFormControl',] }]
    };
    return AppFormControlDirective;
}());
if (false) {
    /** @type {?} */
    AppFormControlDirective.prototype.explicitControl;
    /**
     * @type {?}
     * @private
     */
    AppFormControlDirective.prototype.control;
    /**
     * @type {?}
     * @private
     */
    AppFormControlDirective.prototype.vcr;
    /**
     * @type {?}
     * @private
     */
    AppFormControlDirective.prototype.resolver;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var Colors = {
    MAIN_BLUE: '#4a90e2',
    LIGHT_BLUE: '#70D1FF',
    TEXT_GRAY: '#7f8fa4',
    TEXT_LIGHT_GRAY: '#b7bcbf',
    GRAY_BCG: '#d8d8d8',
    MAIN_BLACK: '#041317',
    MAIN_ORANGE: '#ffac05',
    MAIN_RED: '#f7443a',
    LIGHT_RED: '#FFF3F1',
    MAIN_GREEN: '#61cc61',
    TRANSPARENT: 'transparent',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MissedFieldDirective = /** @class */ (function () {
    function MissedFieldDirective(_parent) {
        this._parent = _parent;
        this._fields = [];
        this._directiveAlive = true;
    }
    Object.defineProperty(MissedFieldDirective.prototype, "fields", {
        set: /**
         * @param {?} fields
         * @return {?}
         */
        function (fields) {
            this._fields = fields;
            this._updateMissedFields();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MissedFieldDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        if (!this._parent) {
            throw new Error('appForm directive should be applied to element with FormGroupDirective');
        }
        if (this._fields === null) {
            throw new Error('Pass string[] into appMissedField');
        }
        this._form = (/** @type {?} */ (this._parent.form));
        this._updateMissedFields();
        this._subscribeOnFormChanges();
    };
    /**
     * @return {?}
     */
    MissedFieldDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._directiveAlive = false;
    };
    /**
     * @private
     * @param {?=} form
     * @return {?}
     */
    MissedFieldDirective.prototype._updateMissedFields = /**
     * @private
     * @param {?=} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        if (form === void 0) { form = this._form; }
        if (form) {
            /** @type {?} */
            var timeoutTime = 0;
            setTimeout((/**
             * @return {?}
             */
            function () {
                Object
                    .keys(form.controls)
                    .forEach((/**
                 * @param {?} key
                 * @return {?}
                 */
                function (key) {
                    /** @type {?} */
                    var control = form.controls[key];
                    /** @type {?} */
                    var isControlEmpty = control.value === null ||
                        control.value === undefined ||
                        control.value === '' ||
                        (Array.isArray(control.value) && control.value.length === 0);
                    /** @type {?} */
                    var isControlDisabled = control.disabled;
                    if (control instanceof DynamicFormGroup) {
                        _this._updateMissedFields(control);
                    }
                    else if (_this._fields.includes(key) && control.hasOwnProperty('parentElementRef')) {
                        /** @type {?} */
                        var parent_1 = control['parentElementRef'];
                        parent_1.style.backgroundColor = (isControlEmpty && !isControlDisabled) ? Colors.LIGHT_RED : Colors.TRANSPARENT;
                    }
                }));
            }), timeoutTime);
        }
    };
    /**
     * @private
     * @return {?}
     */
    MissedFieldDirective.prototype._subscribeOnFormChanges = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this._form
            .valueChanges
            .pipe(takeWhile$1((/**
         * @return {?}
         */
        function () { return _this._directiveAlive; })))
            .subscribe((/**
         * @return {?}
         */
        function () { return _this._updateMissedFields(); }));
    };
    MissedFieldDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[appMissedField]'
                },] }
    ];
    /** @nocollapse */
    MissedFieldDirective.ctorParameters = function () { return [
        { type: FormGroupDirective }
    ]; };
    MissedFieldDirective.propDecorators = {
        fields: [{ type: Input, args: ['appMissedField',] }]
    };
    return MissedFieldDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    MissedFieldDirective.prototype._form;
    /**
     * @type {?}
     * @private
     */
    MissedFieldDirective.prototype._fields;
    /**
     * @type {?}
     * @private
     */
    MissedFieldDirective.prototype._directiveAlive;
    /**
     * @type {?}
     * @private
     */
    MissedFieldDirective.prototype._parent;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FormValidationModule = /** @class */ (function () {
    function FormValidationModule() {
    }
    FormValidationModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatFormFieldModule
                    ],
                    declarations: [
                        AppFormDirective,
                        AppFormControlDirective,
                        AppErrorsComponent,
                        MissedFieldDirective
                    ],
                    entryComponents: [
                        AppErrorsComponent
                    ],
                    exports: [
                        AppFormDirective,
                        AppFormControlDirective,
                        AppErrorsComponent,
                        MissedFieldDirective
                    ]
                },] }
    ];
    return FormValidationModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmailFormModule = /** @class */ (function () {
    function EmailFormModule() {
    }
    EmailFormModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatFormFieldModule,
                        MatInputModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FormValidationModule
                    ],
                    declarations: [EmailFormComponent],
                    exports: [EmailFormComponent]
                },] }
    ];
    return EmailFormModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PhoneNumberForm = /** @class */ (function () {
    function PhoneNumberForm() {
        this.phone_number = '';
        this.phone_ext = '';
    }
    __decorate([
        MyIsNotEmpty(),
        __metadata("design:type", Object)
    ], PhoneNumberForm.prototype, "phone_number", void 0);
    __decorate([
        MyIsOptional(),
        MyIsNumberString(),
        MyMaxLength(6),
        __metadata("design:type", Object)
    ], PhoneNumberForm.prototype, "phone_ext", void 0);
    return PhoneNumberForm;
}());
if (false) {
    /** @type {?} */
    PhoneNumberForm.prototype.phone_number;
    /** @type {?} */
    PhoneNumberForm.prototype.phone_ext;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PhoneNumberFormComponent = /** @class */ (function (_super) {
    __extends(PhoneNumberFormComponent, _super);
    function PhoneNumberFormComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.required = true;
        _this.InputHelper = InputHelper;
        return _this;
    }
    PhoneNumberFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-phone-number-form',
                    template: "<form\n  class=\"phone-number-input\"\n  [formGroup]=\"form\"\n>\n  <mat-form-field class=\"form-field required-field\">\n    <input\n      type=\"tel\"\n      class=\"form-field__phone\"\n      matInput\n      appFormControl\n      [placeholder]=\"'Phone Number' + (required ? ' *' : '')\"\n      formControlName=\"phone_number\"\n    >\n  </mat-form-field>\n\n  <mat-form-field class=\"form-field extention\">\n    <input\n      type=\"text\"\n      class=\"form-field__phone\"\n      matInput\n      appFormControl\n      placeholder=\"Phone Ext\"\n      formControlName=\"phone_ext\"\n      maxlength=\"6\"\n      (keypress)=\"InputHelper.numberInput($event)\"\n    >\n  </mat-form-field>\n</form>\n",
                    styles: [".phone-number-input{display:flex;justify-content:space-between;align-items:baseline}.phone-number-input .extention{width:30%;margin-left:5%}"]
                }] }
    ];
    PhoneNumberFormComponent.propDecorators = {
        required: [{ type: Input }]
    };
    return PhoneNumberFormComponent;
}(FormComponent));
if (false) {
    /** @type {?} */
    PhoneNumberFormComponent.prototype.required;
    /** @type {?} */
    PhoneNumberFormComponent.prototype.InputHelper;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PhoneNumberFormModule = /** @class */ (function () {
    function PhoneNumberFormModule() {
    }
    PhoneNumberFormModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        FormValidationModule,
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MatInputModule
                    ],
                    declarations: [PhoneNumberFormComponent],
                    exports: [PhoneNumberFormComponent]
                },] }
    ];
    return PhoneNumberFormModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StartEndDatetimeForm = /** @class */ (function () {
    function StartEndDatetimeForm() {
        this.start_datetime = null;
        this.end_datetime = null;
    }
    Object.defineProperty(StartEndDatetimeForm.prototype, "formattedDate", {
        get: /**
         * @template THIS
         * @this {THIS}
         * @return {THIS}
         */
        function () {
            (/** @type {?} */ (this))._setHours('start_datetime', 0, 0, 0);
            (/** @type {?} */ (this))._setHours('end_datetime', 23, 59, 59);
            return (/** @type {?} */ (this));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StartEndDatetimeForm.prototype, "hasDateTimeRestriction", {
        get: /**
         * @return {?}
         */
        function () {
            return !!this.start_datetime || !!this.end_datetime;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} fieldName
     * @param {?} hours
     * @param {?} minutes
     * @param {?} seconds
     * @return {?}
     */
    StartEndDatetimeForm.prototype._setHours = /**
     * @param {?} fieldName
     * @param {?} hours
     * @param {?} minutes
     * @param {?} seconds
     * @return {?}
     */
    function (fieldName, hours, minutes, seconds) {
        if (!!this[fieldName]) {
            if (typeof this[fieldName] === 'string') {
                this[fieldName] = new Date(this[fieldName]);
            }
            this[fieldName].setHours(hours, minutes, seconds);
        }
    };
    __decorate([
        Type(decoratorType(Date)),
        __metadata("design:type", Date)
    ], StartEndDatetimeForm.prototype, "start_datetime", void 0);
    __decorate([
        Type(decoratorType(Date)),
        __metadata("design:type", Date)
    ], StartEndDatetimeForm.prototype, "end_datetime", void 0);
    return StartEndDatetimeForm;
}());
if (false) {
    /** @type {?} */
    StartEndDatetimeForm.prototype.start_datetime;
    /** @type {?} */
    StartEndDatetimeForm.prototype.end_datetime;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StartEndDatetimeFormComponent = /** @class */ (function (_super) {
    __extends(StartEndDatetimeFormComponent, _super);
    function StartEndDatetimeFormComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.startDateFieldName = 'start_datetime';
        _this.endDateFieldName = 'end_datetime';
        _this.minDate = new Date();
        _this.clearable = false;
        return _this;
    }
    StartEndDatetimeFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-start-end-datetime-form',
                    template: "<form\n  *ngIf=\"!!form\"\n  [formGroup]=\"form\"\n  class=\"form-row\"\n>\n  <app-date-input\n    title=\"Start Date\"\n    [formControlNameString]=\"startDateFieldName\"\n    [form]=\"form\"\n    [minDate]=\"minDate\"\n    [maxDate]=\"maxDate\"\n    [clearable]=\"clearable\"\n    (onDateChange)=\"emitValue()\"\n  ></app-date-input>\n\n  <app-date-input\n    title=\"End Date\"\n    [formControlNameString]=\"endDateFieldName\"\n    [form]=\"form\"\n    [minDate]=\"minDate\"\n    [maxDate]=\"maxDate\"\n    [clearable]=\"clearable\"\n    (onDateChange)=\"emitValue()\"\n  ></app-date-input>\n</form>\n",
                    styles: [".form-row{display:flex;justify-content:space-between;align-items:center}.form-row>*{width:45%}"]
                }] }
    ];
    StartEndDatetimeFormComponent.propDecorators = {
        startDateFieldName: [{ type: Input }],
        endDateFieldName: [{ type: Input }],
        minDate: [{ type: Input }],
        maxDate: [{ type: Input }],
        clearable: [{ type: Input }]
    };
    return StartEndDatetimeFormComponent;
}(FormComponent));
if (false) {
    /** @type {?} */
    StartEndDatetimeFormComponent.prototype.startDateFieldName;
    /** @type {?} */
    StartEndDatetimeFormComponent.prototype.endDateFieldName;
    /** @type {?} */
    StartEndDatetimeFormComponent.prototype.minDate;
    /** @type {?} */
    StartEndDatetimeFormComponent.prototype.maxDate;
    /** @type {?} */
    StartEndDatetimeFormComponent.prototype.clearable;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DateInputComponent = /** @class */ (function () {
    function DateInputComponent() {
        this.minDate = new Date();
        this.clearable = false;
        this.onDateChange = new EventEmitter();
    }
    Object.defineProperty(DateInputComponent.prototype, "hasValue", {
        get: /**
         * @return {?}
         */
        function () {
            return !!this.form.controls[this.formControlNameString].value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} date
     * @return {?}
     */
    DateInputComponent.prototype.emitValue = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        /** @type {?} */
        var offset = date.getTimezoneOffset();
        /** @type {?} */
        var dateWrapped = moment(date);
        if (offset > 0) {
            dateWrapped = moment(date).add(1, 'd');
        }
        /** @type {?} */
        var formattedDate = dateWrapped.format('YYYY-MM-DD');
        this.form.controls[this.formControlNameString].setValue(formattedDate);
        this.onDateChange.emit(date);
    };
    /**
     * @return {?}
     */
    DateInputComponent.prototype.clearField = /**
     * @return {?}
     */
    function () {
        this.form.controls[this.formControlNameString].setValue(null);
        this.onDateChange.emit(null);
    };
    DateInputComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-date-input',
                    template: "<form\n  *ngIf=\"!!form\"\n  [formGroup]=\"form\"\n  style=\"position: relative\"\n>\n  <span\n    *ngIf=\"clearable && hasValue\"\n    class=\"clear-icon\"\n    (click)=\"clearField()\"\n  >Clear</span>\n\n  <app-input-wrapper\n    [title]=\"title\"\n    [formControlNameString]=\"formControlNameString\"\n  >\n    <input\n      matInput\n      appFormControl\n      [matDatepicker]=\"datepicker\"\n      [min]=\"minDate\"\n      [max]=\"maxDate\"\n      [formControlName]=\"formControlNameString\"\n      (dateChange)=\"emitValue($event.value)\"\n    >\n    <mat-datepicker-toggle matSuffix [for]=\"datepicker\"></mat-datepicker-toggle>\n    <mat-datepicker #datepicker></mat-datepicker>\n\n  </app-input-wrapper>\n</form>\n",
                    styles: ["::ng-deep .mat-calendar-body-selected{color:#fff}.mat-checkbox-indeterminate.mat-accent .mat-checkbox-background,::ng-deep.mat-checkbox-checked.mat-accent .mat-checkbox-background{background-color:#4a90e2;border-radius:4px}::ng-deep.mat-checkbox-frame{border-width:1px!important;border-color:rgba(0,0,0,.38);border-radius:5px!important}::ng-deep .mat-checkbox-label{white-space:normal;position:relative;top:3px}::ng-deep .mat-radio-label-content{white-space:normal;color:#7f8fa4}::ng-deep .mat-tooltip{font-size:12px}.clear-icon{font-size:13px;color:#7f8fa4;cursor:pointer;opacity:.7;position:absolute;top:9px;right:1px}"]
                }] }
    ];
    DateInputComponent.propDecorators = {
        title: [{ type: Input }],
        form: [{ type: Input }],
        formControlNameString: [{ type: Input }],
        minDate: [{ type: Input }],
        maxDate: [{ type: Input }],
        clearable: [{ type: Input }],
        onDateChange: [{ type: Output }]
    };
    return DateInputComponent;
}());
if (false) {
    /** @type {?} */
    DateInputComponent.prototype.title;
    /** @type {?} */
    DateInputComponent.prototype.form;
    /** @type {?} */
    DateInputComponent.prototype.formControlNameString;
    /** @type {?} */
    DateInputComponent.prototype.minDate;
    /** @type {?} */
    DateInputComponent.prototype.maxDate;
    /** @type {?} */
    DateInputComponent.prototype.clearable;
    /** @type {?} */
    DateInputComponent.prototype.onDateChange;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var MatIcon = {
    CALENDAR: 'calendar',
    QUESTION_IN_CIRCLE: 'question_in_the_circle',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InputWrapperComponent = /** @class */ (function () {
    function InputWrapperComponent(_parentForm) {
        this._parentForm = _parentForm;
        this.showSpinner = false;
        this.noForm = false;
    }
    /**
     * @return {?}
     */
    InputWrapperComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._setFormGroup();
    };
    Object.defineProperty(InputWrapperComponent.prototype, "isInputInvalid", {
        get: /**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var control = this.form.controls[this.formControlNameString];
            return control.invalid && control.touched && !!control.errors && (!!control.errors ? control.errors.length > 0 : false);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @private
     * @return {?}
     */
    InputWrapperComponent.prototype._setFormGroup = /**
     * @private
     * @return {?}
     */
    function () {
        if (!this._parentForm && !this.noForm) {
            throw new Error('<app-input-wrapper> should be used inside FormGroup or with noForm flag');
        }
        else if (this._parentForm && !this.noForm) {
            this.form = (/** @type {?} */ (this._parentForm.form));
        }
    };
    InputWrapperComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-input-wrapper',
                    template: "<ng-template #input>\n  <mat-icon\n    *ngIf=\"iconBefore\"\n    class=\"icon icon__before\"\n    [svgIcon]=\"iconBefore\"\n  ></mat-icon>\n  <ng-content></ng-content>\n  <mat-icon\n    *ngIf=\"iconAfter\"\n    class=\"icon icon__after\"\n    [svgIcon]=\"iconAfter\"\n  ></mat-icon>\n</ng-template>\n\n<div\n  *ngIf=\"title\"\n  class=\"input-title\"\n>\n  {{ title }}\n</div>\n\n<form\n  *ngIf=\"!!form && !noForm\"\n  class=\"input-wrapper\"\n  [class.icon-before]=\"iconBefore\"\n  [class.icon-after]=\"iconAfter\"\n  [class.invalid]=\"isInputInvalid\"\n  [formGroup]=\"form\"\n>\n  <ng-container *ngTemplateOutlet=\"input\"></ng-container>\n</form>\n\n<div\n  *ngIf=\"noForm\"\n  class=\"input-wrapper\"\n>\n  <ng-container *ngTemplateOutlet=\"input\"></ng-container>\n</div>\n",
                    styles: [".input-title{font-size:15px;margin-bottom:10px}.icon{width:16px;height:16px;position:absolute;top:14px}.icon__before{left:16px}.icon__after{right:16px}.icon ::ng-deep svg path{fill:#e0e2e5}.input-wrapper{position:relative;margin:2px}.input-wrapper ::ng-deep .dollar-sign{position:absolute;top:15px;left:15px;font-size:15px}.input-wrapper ::ng-deep input.price{padding-right:4px;padding-left:24px}.input-wrapper.icon-before ::ng-deep input,.input-wrapper.icon-before ::ng-deep textarea{padding-left:calc(12px + 16px + 16px)}.input-wrapper.icon-after ::ng-deep input,.input-wrapper.icon-after ::ng-deep textarea{padding-right:calc(12px + 16px + 16px)}.input-wrapper ::ng-deep [matsuffix]{position:absolute;top:0;right:0}.input-wrapper ::ng-deep input,.input-wrapper ::ng-deep mat-select ::ng-deep .mat-select-trigger,.input-wrapper ::ng-deep textarea{padding:12px 15px;border:1px solid #e0e2e5;border-radius:6px;font-size:15px}.input-wrapper ::ng-deep input::-webkit-input-placeholder,.input-wrapper ::ng-deep mat-select ::ng-deep .mat-select-trigger::-webkit-input-placeholder,.input-wrapper ::ng-deep textarea::-webkit-input-placeholder{color:#7f8fa4}.input-wrapper ::ng-deep input::-moz-placeholder,.input-wrapper ::ng-deep mat-select ::ng-deep .mat-select-trigger::-moz-placeholder,.input-wrapper ::ng-deep textarea::-moz-placeholder{color:#7f8fa4}.input-wrapper ::ng-deep input::-ms-input-placeholder,.input-wrapper ::ng-deep mat-select ::ng-deep .mat-select-trigger::-ms-input-placeholder,.input-wrapper ::ng-deep textarea::-ms-input-placeholder{color:#7f8fa4}.input-wrapper ::ng-deep input::placeholder,.input-wrapper ::ng-deep mat-select ::ng-deep .mat-select-trigger::placeholder,.input-wrapper ::ng-deep textarea::placeholder{color:#7f8fa4}.input-wrapper ::ng-deep input:focus,.input-wrapper ::ng-deep mat-select ::ng-deep .mat-select-trigger:focus,.input-wrapper ::ng-deep textarea:focus{outline:0;border-color:#4a90e2;box-shadow:0 0 0 1px #4a90e2}.input-wrapper ::ng-deep input[disabled],.input-wrapper ::ng-deep mat-select ::ng-deep .mat-select-trigger[disabled],.input-wrapper ::ng-deep textarea[disabled]{border-style:dashed}.input-wrapper ::ng-deep mat-select ::ng-deep .mat-select-trigger{padding:14px 15px}.input-wrapper ::ng-deep .mat-input-element{padding-left:15px!important}.input-wrapper ::ng-deep input,.input-wrapper ::ng-deep textarea{width:calc(100% - 30px);resize:none}.input-wrapper.invalid ::ng-deep input,.input-wrapper.invalid ::ng-deep mat-select ::ng-deep .mat-select-trigger,.input-wrapper.invalid ::ng-deep textarea{border-color:#f7443a;box-shadow:0 0 0 1px #f7443a}.input-wrapper.invalid ::ng-deep .icon svg path{fill:#f7443a}"]
                }] }
    ];
    /** @nocollapse */
    InputWrapperComponent.ctorParameters = function () { return [
        { type: FormGroupDirective, decorators: [{ type: Optional }] }
    ]; };
    InputWrapperComponent.propDecorators = {
        title: [{ type: Input }],
        iconBefore: [{ type: Input }],
        iconAfter: [{ type: Input }],
        showSpinner: [{ type: Input }],
        noForm: [{ type: Input }],
        formControlNameString: [{ type: Input }]
    };
    return InputWrapperComponent;
}());
if (false) {
    /** @type {?} */
    InputWrapperComponent.prototype.title;
    /** @type {?} */
    InputWrapperComponent.prototype.iconBefore;
    /** @type {?} */
    InputWrapperComponent.prototype.iconAfter;
    /** @type {?} */
    InputWrapperComponent.prototype.showSpinner;
    /** @type {?} */
    InputWrapperComponent.prototype.noForm;
    /** @type {?} */
    InputWrapperComponent.prototype.formControlNameString;
    /** @type {?} */
    InputWrapperComponent.prototype.form;
    /**
     * @type {?}
     * @private
     */
    InputWrapperComponent.prototype._parentForm;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InputWrapperModule = /** @class */ (function () {
    function InputWrapperModule() {
    }
    InputWrapperModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [InputWrapperComponent],
                    exports: [InputWrapperComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FormValidationModule,
                        MatIconModule
                    ]
                },] }
    ];
    return InputWrapperModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DateInputModule = /** @class */ (function () {
    function DateInputModule() {
    }
    DateInputModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [DateInputComponent],
                    exports: [DateInputComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FormValidationModule,
                        MatInputModule,
                        MatDatepickerModule,
                        MatNativeDateModule,
                        InputWrapperModule,
                        MatIconModule$1
                    ]
                },] }
    ];
    return DateInputModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StartEndDatetimeFormModule = /** @class */ (function () {
    function StartEndDatetimeFormModule() {
    }
    StartEndDatetimeFormModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [StartEndDatetimeFormComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        DateInputModule
                    ],
                    exports: [StartEndDatetimeFormComponent]
                },] }
    ];
    return StartEndDatetimeFormModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BillingPhoneNumberForm = /** @class */ (function () {
    function BillingPhoneNumberForm() {
        this.billing_phone_number = '';
        this.billing_phone_ext = '';
    }
    __decorate([
        MyIsNotEmpty(),
        __metadata("design:type", Object)
    ], BillingPhoneNumberForm.prototype, "billing_phone_number", void 0);
    __decorate([
        MyIsOptional(),
        MyIsNumberString(),
        MyMaxLength(6),
        __metadata("design:type", Object)
    ], BillingPhoneNumberForm.prototype, "billing_phone_ext", void 0);
    return BillingPhoneNumberForm;
}());
if (false) {
    /** @type {?} */
    BillingPhoneNumberForm.prototype.billing_phone_number;
    /** @type {?} */
    BillingPhoneNumberForm.prototype.billing_phone_ext;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BillingPhoneNumberFormComponent = /** @class */ (function (_super) {
    __extends(BillingPhoneNumberFormComponent, _super);
    function BillingPhoneNumberFormComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.required = true;
        _this.InputHelper = InputHelper;
        return _this;
    }
    BillingPhoneNumberFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-billing-phone-number-form',
                    template: "<form\n  class=\"phone-number-input\"\n  [formGroup]=\"form\"\n>\n  <mat-form-field class=\"form-field required-field\">\n    <input\n      type=\"tel\"\n      class=\"form-field__phone\"\n      matInput\n      appFormControl\n      [placeholder]=\"'Phone Number' + (required ? ' *' : '')\"\n      formControlName=\"billing_phone_number\"\n    >\n  </mat-form-field>\n\n  <mat-form-field class=\"form-field extention\">\n    <input\n      type=\"text\"\n      class=\"form-field__phone\"\n      matInput\n      appFormControl\n      placeholder=\"Phone Ext\"\n      formControlName=\"billing_phone_ext\"\n      maxlength=\"6\"\n      (keypress)=\"InputHelper.numberInput($event)\"\n    >\n  </mat-form-field>\n</form>\n",
                    styles: [".phone-number-input{display:flex;justify-content:space-between;align-items:baseline}.phone-number-input .extention{width:30%;margin-left:5%}"]
                }] }
    ];
    BillingPhoneNumberFormComponent.propDecorators = {
        required: [{ type: Input }]
    };
    return BillingPhoneNumberFormComponent;
}(FormComponent));
if (false) {
    /** @type {?} */
    BillingPhoneNumberFormComponent.prototype.required;
    /** @type {?} */
    BillingPhoneNumberFormComponent.prototype.InputHelper;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BillingPhoneNumberFormModule = /** @class */ (function () {
    function BillingPhoneNumberFormModule() {
    }
    BillingPhoneNumberFormModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        FormValidationModule,
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MatInputModule
                    ],
                    declarations: [BillingPhoneNumberFormComponent],
                    exports: [BillingPhoneNumberFormComponent]
                },] }
    ];
    return BillingPhoneNumberFormModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CheckboxesArrayComponent = /** @class */ (function () {
    function CheckboxesArrayComponent() {
    }
    /**
     * @param {?} type
     * @return {?}
     */
    CheckboxesArrayComponent.prototype.isChoiceChecked = /**
     * @param {?} type
     * @return {?}
     */
    function (type) {
        return (!!this.formField && !!this.formField.value) ? this.formField.value.includes(type) : false;
    };
    /**
     * @param {?} type
     * @return {?}
     */
    CheckboxesArrayComponent.prototype.toggleChoice = /**
     * @param {?} type
     * @return {?}
     */
    function (type) {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var formValue = _this.formField.value;
            /** @type {?} */
            var typeIndex = formValue.indexOf(type);
            if (typeIndex === -1) {
                formValue.push(type);
            }
            else {
                formValue.splice(typeIndex, 1);
            }
            _this.formField.setValue(formValue);
            _this.formField.markAsTouched();
        }), 0);
    };
    CheckboxesArrayComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-checkboxes-array',
                    template: "<div\n  *ngIf=\"!!formField && !!choicesMap\"\n  class=\"checkbox-choices\"\n>\n  <mat-checkbox\n    *ngFor=\"let choice of choicesMap | keyvalue\"\n    [checked]=\"isChoiceChecked(choice.value)\"\n    (click)=\"toggleChoice(choice.value)\"\n  >\n    {{ choice.key }}\n  </mat-checkbox>\n</div>\n",
                    styles: [".checkbox-choices{display:flex;flex-wrap:wrap}.checkbox-choices mat-checkbox{width:50%;margin-bottom:5px}"]
                }] }
    ];
    CheckboxesArrayComponent.propDecorators = {
        choicesMap: [{ type: Input }],
        formField: [{ type: Input }]
    };
    return CheckboxesArrayComponent;
}());
if (false) {
    /** @type {?} */
    CheckboxesArrayComponent.prototype.choicesMap;
    /** @type {?} */
    CheckboxesArrayComponent.prototype.formField;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CheckboxesArrayModule = /** @class */ (function () {
    function CheckboxesArrayModule() {
    }
    CheckboxesArrayModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatCheckboxModule,
                        FormsModule,
                        ReactiveFormsModule
                    ],
                    declarations: [CheckboxesArrayComponent],
                    exports: [CheckboxesArrayComponent],
                },] }
    ];
    return CheckboxesArrayModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AutocompleteComponent = /** @class */ (function () {
    function AutocompleteComponent() {
        this.formChange = new EventEmitter();
        // Array of objects that will be shown in autocomplete
        this.array = [];
        this.autoSetFirstItemInArray = true;
        this.required = false;
        // On selector element click event emitter
        this.onElementClick = new EventEmitter();
    }
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.displayFn = this._displayFnConstructor();
        this.filteredArray = this.form
            .controls[this.controlName]
            .valueChanges
            .pipe(startWith(null), debounceTime(200), distinctUntilChanged(), map((/**
         * @param {?} name
         * @return {?}
         */
        function (name) { return _this._filterAutocomplete(name); })));
    };
    /**
     * @return {?}
     */
    AutocompleteComponent.prototype.setAutocompleteValue = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.autoSetFirstItemInArray) {
            /** @type {?} */
            var array = this._filterAutocomplete(this.inputValue);
            /** @type {?} */
            var inputExistsInArray = !!array.find((/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return (item[_this.valueParameter] || item) === _this.form.controls[_this.controlName].value; }));
            if (this.array.length !== array.length && !inputExistsInArray) {
                this.form.controls[this.controlName].setValue(this.lastArrayElement[this.valueParameter] || this.lastArrayElement);
            }
            this.formChange.emit(this.form);
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AutocompleteComponent.prototype.setInputValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.inputValue = value;
    };
    /**
     * @param {?} element
     * @return {?}
     */
    AutocompleteComponent.prototype.emitElementClick = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        this.setInputValue(element[this.displayParameter] || element);
        this.onElementClick.emit(element);
    };
    /**
     * @private
     * @return {?}
     */
    AutocompleteComponent.prototype._displayFnConstructor = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        return (/**
         * @param {?} element
         * @return {?}
         */
        function (element) {
            if (_this.displayParameter && _this.valueParameter && element) {
                return element[_this.displayParameter]
                    ? element[_this.displayParameter]
                    : _this.array.find((/**
                     * @param {?} item
                     * @return {?}
                     */
                    function (item) { return item[_this.valueParameter] === element; }))[_this.displayParameter];
            }
            else {
                return element;
            }
        });
    };
    /**
     * @private
     * @param {?} val
     * @return {?}
     */
    AutocompleteComponent.prototype._filterAutocomplete = /**
     * @private
     * @param {?} val
     * @return {?}
     */
    function (val) {
        var _this = this;
        /** @type {?} */
        var filteredArr = val
            ? this.array.filter((/**
             * @param {?} s
             * @return {?}
             */
            function (s) {
                /** @type {?} */
                var inputString = (typeof val === 'object' && !!val[_this.displayParameter])
                    ? val[_this.displayParameter].toString().toLowerCase()
                    : val.toString().toLowerCase();
                /** @type {?} */
                var itemDisplayString = (typeof s === 'object' && !!s[_this.displayParameter])
                    ? s[_this.displayParameter].toString().toLowerCase()
                    : s.toString().toLowerCase();
                /** @type {?} */
                var itemValueString = (typeof s === 'object' && !!s[_this.displayParameter])
                    ? s[_this.valueParameter].toString().toLowerCase()
                    : s.toString().toLowerCase();
                return !!itemDisplayString.match(new RegExp(inputString, 'i')) ||
                    !!itemValueString.match(new RegExp('^' + inputString + '$', 'i'));
            }))
            : this.array;
        this.lastArrayElement = filteredArr[0] || this.lastArrayElement;
        return filteredArr;
    };
    AutocompleteComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-autocomplete',
                    template: "<form [formGroup]=\"form\" novalidate>\n\n  <mat-form-field class=\"form-field\">\n    <input\n      class=\"form-field__text\"\n      matInput\n      #input\n      [placeholder]=\"placeholder\"\n      [matAutocomplete]=\"autocomplete\"\n      [formControlName]=\"controlName\"\n      (keyup)=\"setInputValue(input.value)\"\n      (blur)=\"setAutocompleteValue()\"\n      [required]=\"required\"\n      appFormControl\n    >\n  </mat-form-field>\n\n  <mat-autocomplete\n    #autocomplete=\"matAutocomplete\"\n    class=\"form-field\"\n    aria-required=\"true\"\n    [displayWith]=\"displayFn\"\n  >\n    <mat-option\n      *ngFor=\"let element of filteredArray | async\"\n      [value]=\"element[valueParameter] || element\"\n      (click)=\"emitElementClick(element)\"\n    >\n      {{ element[displayParameter] || element }}\n    </mat-option>\n  </mat-autocomplete>\n</form>\n",
                    styles: [""]
                }] }
    ];
    AutocompleteComponent.propDecorators = {
        placeholder: [{ type: Input }],
        form: [{ type: Input }],
        formChange: [{ type: Output }],
        controlName: [{ type: Input }],
        array: [{ type: Input }],
        displayParameter: [{ type: Input }],
        valueParameter: [{ type: Input }],
        autoSetFirstItemInArray: [{ type: Input }],
        required: [{ type: Input }],
        onElementClick: [{ type: Output }]
    };
    return AutocompleteComponent;
}());
if (false) {
    /** @type {?} */
    AutocompleteComponent.prototype.placeholder;
    /** @type {?} */
    AutocompleteComponent.prototype.form;
    /** @type {?} */
    AutocompleteComponent.prototype.formChange;
    /** @type {?} */
    AutocompleteComponent.prototype.controlName;
    /** @type {?} */
    AutocompleteComponent.prototype.array;
    /** @type {?} */
    AutocompleteComponent.prototype.displayParameter;
    /** @type {?} */
    AutocompleteComponent.prototype.valueParameter;
    /** @type {?} */
    AutocompleteComponent.prototype.autoSetFirstItemInArray;
    /** @type {?} */
    AutocompleteComponent.prototype.required;
    /** @type {?} */
    AutocompleteComponent.prototype.onElementClick;
    /** @type {?} */
    AutocompleteComponent.prototype.inputValue;
    /** @type {?} */
    AutocompleteComponent.prototype.lastArrayElement;
    /** @type {?} */
    AutocompleteComponent.prototype.filteredArray;
    /** @type {?} */
    AutocompleteComponent.prototype.displayFn;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AutocompleteModule = /** @class */ (function () {
    function AutocompleteModule() {
    }
    AutocompleteModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        MatInputModule,
                        MatAutocompleteModule,
                        FormValidationModule
                    ],
                    declarations: [
                        AutocompleteComponent
                    ],
                    exports: [
                        AutocompleteComponent
                    ]
                },] }
    ];
    return AutocompleteModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var ChoicesSortingMethod = {
    VALUE_ASC_STRING: 0,
    VALUE_DESC_STRING: 1,
    KEY_ASC_STRING: 2,
    KEY_DESC_STRING: 3,
    VALUE_ASC_NUMBER: 4,
    VALUE_DESC_NUMBER: 5,
    KEY_ASC_NUMBER: 6,
    KEY_DESC_NUMBER: 7,
};
ChoicesSortingMethod[ChoicesSortingMethod.VALUE_ASC_STRING] = 'VALUE_ASC_STRING';
ChoicesSortingMethod[ChoicesSortingMethod.VALUE_DESC_STRING] = 'VALUE_DESC_STRING';
ChoicesSortingMethod[ChoicesSortingMethod.KEY_ASC_STRING] = 'KEY_ASC_STRING';
ChoicesSortingMethod[ChoicesSortingMethod.KEY_DESC_STRING] = 'KEY_DESC_STRING';
ChoicesSortingMethod[ChoicesSortingMethod.VALUE_ASC_NUMBER] = 'VALUE_ASC_NUMBER';
ChoicesSortingMethod[ChoicesSortingMethod.VALUE_DESC_NUMBER] = 'VALUE_DESC_NUMBER';
ChoicesSortingMethod[ChoicesSortingMethod.KEY_ASC_NUMBER] = 'KEY_ASC_NUMBER';
ChoicesSortingMethod[ChoicesSortingMethod.KEY_DESC_NUMBER] = 'KEY_DESC_NUMBER';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var keyAscOrderString = (/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function (a, b) {
    return stringAsc(a.key.toString(), b.key.toString());
});
var ɵ0 = keyAscOrderString;
/** @type {?} */
var keyDescOrderString = (/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function (a, b) {
    return stringDesc(a.key.toString(), b.key.toString());
});
var ɵ1 = keyDescOrderString;
/** @type {?} */
var valueAscOrderString = (/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function (a, b) {
    return stringAsc(a.value.toString(), b.value.toString());
});
var ɵ2 = valueAscOrderString;
/** @type {?} */
var valueDescOrderString = (/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function (a, b) {
    return stringDesc(a.value.toString(), b.value.toString());
});
var ɵ3 = valueDescOrderString;
/** @type {?} */
var keyAscOrderNumber = (/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function (a, b) {
    return numberAsc(+a.key, +b.key);
});
var ɵ4 = keyAscOrderNumber;
/** @type {?} */
var keyDescOrderNumber = (/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function (a, b) {
    return numberDesc(+a.key, +b.key);
});
var ɵ5 = keyDescOrderNumber;
/** @type {?} */
var valueAscOrderNumber = (/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function (a, b) {
    return numberAsc(+a.value, +b.value);
});
var ɵ6 = valueAscOrderNumber;
/** @type {?} */
var valueDescOrderNumber = (/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function (a, b) {
    return numberDesc(+a.value, +b.value);
});
var ɵ7 = valueDescOrderNumber;
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function stringAsc(a, b) {
    return a.localeCompare(b);
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function stringDesc(a, b) {
    return b.localeCompare(a);
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function numberAsc(a, b) {
    return a > b ? 1 : (b > a ? -1 : 0);
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function numberDesc(a, b) {
    return a > b ? 1 : (b > a ? -1 : 0);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SelectComponent = /** @class */ (function (_super) {
    __extends(SelectComponent, _super);
    function SelectComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.multiple = false;
        _this._sortingFunctions = new Map([
            [ChoicesSortingMethod.KEY_ASC_STRING, keyAscOrderString],
            [ChoicesSortingMethod.KEY_DESC_STRING, keyDescOrderString],
            [ChoicesSortingMethod.VALUE_ASC_STRING, valueAscOrderString],
            [ChoicesSortingMethod.VALUE_DESC_STRING, valueDescOrderString],
            [ChoicesSortingMethod.KEY_ASC_NUMBER, keyAscOrderNumber],
            [ChoicesSortingMethod.KEY_DESC_NUMBER, keyDescOrderNumber],
            [ChoicesSortingMethod.VALUE_ASC_NUMBER, valueAscOrderNumber],
            [ChoicesSortingMethod.VALUE_DESC_NUMBER, valueDescOrderNumber],
        ]);
        return _this;
    }
    /**
     * @return {?}
     */
    SelectComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        _super.prototype.ngOnInit.call(this);
        this._chooseSortingMethod();
    };
    Object.defineProperty(SelectComponent.prototype, "sortingFunction", {
        get: /**
         * @return {?}
         */
        function () {
            return this._sortingFunctions.get(this.sortingMethod);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @private
     * @return {?}
     */
    SelectComponent.prototype._chooseSortingMethod = /**
     * @private
     * @return {?}
     */
    function () {
        if (!Object.values(ChoicesSortingMethod).includes(this.sortingMethod)) {
            /** @type {?} */
            var key = Array.from(this.choicesMap.keys())[0];
            this.sortingMethod = typeof key === 'number'
                ? ChoicesSortingMethod.KEY_ASC_NUMBER
                : ChoicesSortingMethod.KEY_ASC_STRING;
        }
    };
    SelectComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-select',
                    template: "<form\n  *ngIf=\"!!form && !noForm\"\n  [formGroup]=\"form\"\n>\n  <app-input-wrapper\n    [title]=\"title\"\n    [formControlNameString]=\"formControlNameString\"\n    [iconBefore]=\"iconBefore\"\n    [iconAfter]=\"iconAfter\"\n    [showSpinner]=\"showSpinner\"\n    [noForm]=\"noForm\"\n  >\n    <mat-select\n      *ngIf=\"sortingFunction\"\n      [formControlName]=\"formControlNameString\"\n      appFormControl\n      [multiple]=\"multiple\"\n    >\n      <mat-option\n        *ngFor=\"let choice of choicesMap | keyvalue: sortingFunction\"\n        [value]=\"choice.value\"\n      >\n        {{ choice.key }}\n      </mat-option>\n    </mat-select>\n  </app-input-wrapper>\n</form>\n",
                    styles: [""]
                }] }
    ];
    SelectComponent.propDecorators = {
        choicesMap: [{ type: Input }],
        sortingMethod: [{ type: Input }],
        multiple: [{ type: Input }]
    };
    return SelectComponent;
}(InputWrapperComponent));
if (false) {
    /** @type {?} */
    SelectComponent.prototype.choicesMap;
    /** @type {?} */
    SelectComponent.prototype.sortingMethod;
    /** @type {?} */
    SelectComponent.prototype.multiple;
    /**
     * @type {?}
     * @private
     */
    SelectComponent.prototype._sortingFunctions;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SelectModule = /** @class */ (function () {
    function SelectModule() {
    }
    SelectModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [SelectComponent],
                    exports: [SelectComponent],
                    imports: [
                        CommonModule,
                        InputWrapperModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FormValidationModule,
                        MatSelectModule
                    ]
                },] }
    ];
    return SelectModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TimeSelectComponent = /** @class */ (function () {
    function TimeSelectComponent() {
        this.ChoicesSortingMethod = ChoicesSortingMethod;
        this.sortingMethod = this.ChoicesSortingMethod.VALUE_ASC_STRING;
    }
    /**
     * @return {?}
     */
    TimeSelectComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._generateTimeRanges();
    };
    /**
     * @private
     * @return {?}
     */
    TimeSelectComponent.prototype._generateTimeRanges = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var am = 'a.m.';
        /** @type {?} */
        var pm = 'p.m.';
        /** @type {?} */
        var hoursInDay = 24;
        /** @type {?} */
        var timeRanges = new Map();
        for (var hour = 1; hour < hoursInDay; hour++) {
            /** @type {?} */
            var dayHalf = hour < (hoursInDay / 2) ? am : pm;
            /** @type {?} */
            var convertTime = hour <= (hoursInDay / 2) ? hour : hour - 12;
            /** @type {?} */
            var displayHour = formatHour(convertTime);
            /** @type {?} */
            var serverHour = formatHour(hour);
            timeRanges.set(displayHour + ":00 " + dayHalf, serverHour + ":00:00");
            timeRanges.set(displayHour + ":30 " + dayHalf, serverHour + ":30:00");
        }
        timeRanges.set("12:00 " + am, '00:00:00');
        timeRanges.set("12:30 " + am, '00:30:00');
        this.timeRange = timeRanges;
        /**
         * @param {?} hour
         * @return {?}
         */
        function formatHour(hour) {
            return hour.toString().length === 1 ? '0' + hour : hour.toString();
        }
    };
    TimeSelectComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-time-select',
                    template: "<form\n  class=\"choose-row\"\n  [ngClass]=\"styleClass\"\n  [formGroup]=\"form\"\n>\n  <app-select\n    [title]=\"title\"\n    [formControlNameString]=\"fieldName\"\n    [choicesMap]=\"timeRange\"\n    [sortingMethod]=\"sortingMethod\"\n  ></app-select>\n</form>\n",
                    styles: [".choose-row,.choose-row mat-form-field{width:100%}"]
                }] }
    ];
    TimeSelectComponent.propDecorators = {
        title: [{ type: Input }],
        form: [{ type: Input }],
        fieldName: [{ type: Input }],
        styleClass: [{ type: Input }]
    };
    return TimeSelectComponent;
}());
if (false) {
    /** @type {?} */
    TimeSelectComponent.prototype.title;
    /** @type {?} */
    TimeSelectComponent.prototype.form;
    /** @type {?} */
    TimeSelectComponent.prototype.fieldName;
    /** @type {?} */
    TimeSelectComponent.prototype.styleClass;
    /** @type {?} */
    TimeSelectComponent.prototype.timeRange;
    /** @type {?} */
    TimeSelectComponent.prototype.ChoicesSortingMethod;
    /** @type {?} */
    TimeSelectComponent.prototype.sortingMethod;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TimeSelectModule = /** @class */ (function () {
    function TimeSelectModule() {
    }
    TimeSelectModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        SelectModule,
                        FormValidationModule
                    ],
                    declarations: [TimeSelectComponent],
                    exports: [TimeSelectComponent]
                },] }
    ];
    return TimeSelectModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var DayHalf = {
    AM: 'am',
    PM: 'pm',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TimeSelectForm = /** @class */ (function () {
    function TimeSelectForm() {
    }
    return TimeSelectForm;
}());
if (false) {
    /** @type {?} */
    TimeSelectForm.prototype.time;
    /** @type {?} */
    TimeSelectForm.prototype.dayHalf;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaginationModel = /** @class */ (function () {
    function PaginationModel(_a) {
        var _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.search, search = _c === void 0 ? '' : _c, _d = _a.for_order, for_order = _d === void 0 ? null : _d;
        this.isLast = false;
        this.page = page;
        this.search = search;
        this.for_order = for_order;
    }
    return PaginationModel;
}());
if (false) {
    /** @type {?} */
    PaginationModel.prototype.page;
    /** @type {?} */
    PaginationModel.prototype.search;
    /** @type {?} */
    PaginationModel.prototype.isLast;
    /** @type {?} */
    PaginationModel.prototype.for_order;
    /* Skipping unhandled member: [key: string]: any;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var CustomDropdownComponent = /** @class */ (function () {
    function CustomDropdownComponent() {
        var _this = this;
        this.list = [];
        this.propertyToShow = 'name';
        this.propertyToCompare = 'id';
        this.selected = [];
        this.pagination = new PaginationModel({});
        this.disabled = false;
        this.showSearchField = true;
        this.clearOnSelectItem = true;
        this.placeholder = '';
        this.onChange = new EventEmitter();
        this.loadMore = new EventEmitter();
        this.reload = new EventEmitter();
        this.searchSubject = new Subject();
        this.expanded = false;
        this.searchSubject.pipe(debounceTime$1(700), distinctUntilChanged$1())
            .subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            _this.reload.emit(_this.pagination);
        }));
    }
    /**
     * @param {?} event
     * @return {?}
     */
    CustomDropdownComponent.prototype.applySearch = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.preventDefault();
        this.pagination.page = 1;
        this.reload.emit(this.pagination);
    };
    /**
     * @return {?}
     */
    CustomDropdownComponent.prototype.onInputFocus = /**
     * @return {?}
     */
    function () {
        this.expanded = true;
    };
    /**
     * @return {?}
     */
    CustomDropdownComponent.prototype.onInputBlur = /**
     * @return {?}
     */
    function () {
        this.expanded = false;
    };
    /**
     * @param {?} item
     * @return {?}
     */
    CustomDropdownComponent.prototype.selectItem = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        if (item instanceof Event || this.disabled || this.isItemSelected(item))
            return;
        this.onChange.emit(item);
        if (this.clearOnSelectItem) {
            this.pagination.page = 1;
            this.pagination.search = item[this.propertyToShow];
            this.reload.emit(this.pagination);
        }
        this.onInputBlur();
    };
    /**
     * @return {?}
     */
    CustomDropdownComponent.prototype.onLoadMore = /**
     * @return {?}
     */
    function () {
        this.pagination.page += 1;
        this.loadMore.emit(this.pagination);
    };
    /**
     * @return {?}
     */
    CustomDropdownComponent.prototype.clearSelection = /**
     * @return {?}
     */
    function () {
        this.pagination = new PaginationModel({});
        this.reload.emit(this.pagination);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    CustomDropdownComponent.prototype.isItemSelected = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var _this = this;
        if (!this.selected)
            return false;
        /** @type {?} */
        var itemValue = item[this.propertyToCompare];
        return !!this.selected.find((/**
         * @param {?} selectedItem
         * @return {?}
         */
        function (selectedItem) {
            return selectedItem[_this.propertyToCompare] === itemValue;
        }));
    };
    CustomDropdownComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-custom-dropdown',
                    template: "<div\n  class=\"dropdown\"\n  [ngClass]=\"{'expanded': expanded, 'disabled': disabled}\"\n  (clickOutside)=\"onInputBlur()\"\n>\n  <form\n    class=\"dropdown__search\"\n    *ngIf=\"showSearchField\"\n    (submit)=\"applySearch($event)\"\n  >\n    <input\n      type=\"text\"\n      [(ngModel)]=\"pagination.search\"\n      [ngModelOptions]=\"{standalone: true}\"\n      [disabled]=\"disabled\"\n      [attr.placeholder]=\"placeholder\"\n      (focus)=\"onInputFocus()\"\n      (ngModelChange)=\"searchSubject.next($event)\"\n    >\n    <button>\n      <mat-icon>search</mat-icon>\n    </button>\n  </form>\n\n  <div\n    class=\"dropdown__list\"\n    [ngClass]=\"{'dropdown__list--expanded': expanded}\"\n  >\n    <div\n      class=\"dropdown__item\"\n      *ngFor=\"let item of list\"\n      (click)=\"selectItem(item)\"\n      [ngClass]=\"{'selected': isItemSelected(item)}\"\n    >\n      {{item[this.propertyToShow]}}\n    </div>\n\n    <div class=\"dropdown__item disabled\" *ngIf=\"list && !list.length\">\n      Not found\n    </div>\n\n    <div class=\"dropdown__item more\" *ngIf=\"!pagination.isLast\" (click)=\"onLoadMore()\">\n      Load More\n    </div>\n  </div>\n</div>\n",
                    styles: [".dropdown{padding:0 4px;background-color:#fff;border:1px solid #eee;height:50px;display:flex;align-items:center;position:relative;border-radius:4px}.dropdown.expanded{border:1px solid #eee;border-bottom:1px solid transparent;border-bottom-left-radius:0;border-bottom-right-radius:0}.dropdown.disabled{opacity:.5;pointer-events:none}.dropdown__search{width:100%;display:flex;align-items:center}.dropdown__search input{max-width:calc(100% - 40px);width:calc(100% - 40px);border:none!important;height:40px}.dropdown__search button{background-color:#ececec;-webkit-appearance:none;border:none;outline:0;width:40px;height:40px;min-width:40px;border-radius:4px;cursor:pointer;transition:.2s}.dropdown__search button:hover{opacity:.8}.dropdown__search button mat-icon{width:18px;height:18px;font-size:18px;margin-top:4px}.dropdown__list{overflow:auto;padding:0 4px;box-sizing:border-box;border-top:1px solid transparent;position:absolute;z-index:9;top:50px;left:0;max-height:0;border-bottom-left-radius:4px;border-bottom-right-radius:4px;margin:-2px -1px 0;width:calc(100% + 2px);background:#fff}.dropdown__list--expanded{max-height:200px;padding:4px;border:1px solid #ececec;border-top:1px solid transparent}.dropdown__item{cursor:pointer;transition:.2s;padding:8px;background-color:#fff;font-size:14px;min-height:40px;box-sizing:border-box;display:flex;align-items:center}.dropdown__item:hover{background-color:#f9f9f9}.dropdown__item.disabled{cursor:auto}.dropdown__item.selected{background-color:#f1f6fd}.dropdown__item.more{background-color:#f9f9f9;border-radius:4px}"]
                }] }
    ];
    /** @nocollapse */
    CustomDropdownComponent.ctorParameters = function () { return []; };
    CustomDropdownComponent.propDecorators = {
        list: [{ type: Input }],
        propertyToShow: [{ type: Input }],
        propertyToCompare: [{ type: Input }],
        selected: [{ type: Input }],
        value: [{ type: Input }],
        pagination: [{ type: Input }],
        disabled: [{ type: Input }],
        showSearchField: [{ type: Input }],
        clearOnSelectItem: [{ type: Input }],
        placeholder: [{ type: Input }],
        onChange: [{ type: Output }],
        loadMore: [{ type: Output }],
        reload: [{ type: Output }]
    };
    return CustomDropdownComponent;
}());
if (false) {
    /** @type {?} */
    CustomDropdownComponent.prototype.list;
    /** @type {?} */
    CustomDropdownComponent.prototype.propertyToShow;
    /** @type {?} */
    CustomDropdownComponent.prototype.propertyToCompare;
    /** @type {?} */
    CustomDropdownComponent.prototype.selected;
    /** @type {?} */
    CustomDropdownComponent.prototype.value;
    /** @type {?} */
    CustomDropdownComponent.prototype.pagination;
    /** @type {?} */
    CustomDropdownComponent.prototype.disabled;
    /** @type {?} */
    CustomDropdownComponent.prototype.showSearchField;
    /** @type {?} */
    CustomDropdownComponent.prototype.clearOnSelectItem;
    /** @type {?} */
    CustomDropdownComponent.prototype.placeholder;
    /** @type {?} */
    CustomDropdownComponent.prototype.onChange;
    /** @type {?} */
    CustomDropdownComponent.prototype.loadMore;
    /** @type {?} */
    CustomDropdownComponent.prototype.reload;
    /** @type {?} */
    CustomDropdownComponent.prototype.searchSubject;
    /** @type {?} */
    CustomDropdownComponent.prototype.expanded;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CustomDropdownModule = /** @class */ (function () {
    function CustomDropdownModule() {
    }
    CustomDropdownModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        MatIconModule$1,
                        ClickOutsideModule
                    ],
                    declarations: [
                        CustomDropdownComponent
                    ],
                    exports: [
                        CustomDropdownComponent
                    ]
                },] }
    ];
    return CustomDropdownModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FormErrors = /** @class */ (function () {
    function FormErrors(form) {
        this.errors = new BehaviorSubject({});
        this._form = form;
        this._subscribeOnFormErrors();
    }
    /**
     * @param {?} externalErrors
     * @return {?}
     */
    FormErrors.prototype.setErrorsFromBackend = /**
     * @param {?} externalErrors
     * @return {?}
     */
    function (externalErrors) {
        var _this = this;
        /** @type {?} */
        var errors = {};
        if (externalErrors && typeof externalErrors === 'object') {
            Object
                .keys(externalErrors)
                .forEach((/**
             * @param {?} key
             * @return {?}
             */
            function (key) {
                /** @type {?} */
                var keyError = externalErrors[key];
                if (typeof keyError === 'string') {
                    keyError = [keyError];
                }
                if (typeof keyError === 'object' && !Array.isArray(keyError)) {
                    _this.setErrorsFromBackend(keyError);
                }
                errors[key] = keyError;
            }));
        }
        this.errors.next(errors);
    };
    /**
     * @private
     * @return {?}
     */
    FormErrors.prototype._subscribeOnFormErrors = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this._form
            .customValidateErrors
            .subscribe((/**
         * @param {?} errors
         * @return {?}
         */
        function (errors) { return _this.errors.next(errors); }));
    };
    return FormErrors;
}());
if (false) {
    /** @type {?} */
    FormErrors.prototype.errors;
    /**
     * @type {?}
     * @private
     */
    FormErrors.prototype._form;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template T
 */
var  /**
 * @abstract
 * @template T
 */
FormComponentContainer = /** @class */ (function () {
    function FormComponentContainer() {
        this.messages = new Messages();
        this._fb = new DynamicFormBuilder();
    }
    /**
     * @return {?}
     */
    FormComponentContainer.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._buildForm();
    };
    /**
     * @protected
     * @param {?} err
     * @return {?}
     */
    FormComponentContainer.prototype._handleBackendErrors = /**
     * @protected
     * @param {?} err
     * @return {?}
     */
    function (err) {
        /** @type {?} */
        var error = err instanceof HttpErrorResponse ? err.error : err;
        this._validateForm();
        this.messages.setBackendErrors(error);
        this.errors.setErrorsFromBackend(error);
    };
    /**
     * @protected
     * @return {?}
     */
    FormComponentContainer.prototype._buildForm = /**
     * @protected
     * @return {?}
     */
    function () {
        this.form = this._getFormGroup();
        this.errors = new FormErrors(this.form);
    };
    /**
     * @protected
     * @param {?=} value
     * @return {?}
     */
    FormComponentContainer.prototype._resetForm = /**
     * @protected
     * @param {?=} value
     * @return {?}
     */
    function (value) {
        if (value === void 0) { value = this._getFormGroup().value; }
        this.form.patchValue(value);
        this.form.markAsUntouched();
    };
    /**
     * @protected
     * @return {?}
     */
    FormComponentContainer.prototype._validateForm = /**
     * @protected
     * @return {?}
     */
    function () {
        if (this.form) {
            this.form.validate();
            this._markFormGroupTouched(this.form);
        }
    };
    /**
     * @protected
     * @param {?} formGroup
     * @return {?}
     */
    FormComponentContainer.prototype._markFormGroupTouched = /**
     * @protected
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        ((/** @type {?} */ (Object)))
            .values(formGroup.controls)
            .forEach((/**
         * @param {?} control
         * @return {?}
         */
        function (control) {
            control.markAsTouched();
            control.markAsDirty();
            if (control.controls) {
                _this._markFormGroupTouched(control);
            }
        }));
    };
    return FormComponentContainer;
}());
if (false) {
    /** @type {?} */
    FormComponentContainer.prototype.form;
    /** @type {?} */
    FormComponentContainer.prototype.errors;
    /** @type {?} */
    FormComponentContainer.prototype.messages;
    /**
     * @type {?}
     * @protected
     */
    FormComponentContainer.prototype._fb;
    /**
     * @abstract
     * @protected
     * @return {?}
     */
    FormComponentContainer.prototype._getFormGroup = function () { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DateFilterComponent = /** @class */ (function (_super) {
    __extends(DateFilterComponent, _super);
    function DateFilterComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.title = 'Period of time';
        _this.minDate = null;
        _this.maxDate = new Date();
        _this.clearable = false;
        _this.onDateChange = new EventEmitter();
        return _this;
    }
    Object.defineProperty(DateFilterComponent.prototype, "dateValue", {
        set: /**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), startDate = _b[0], endDate = _b[1];
            if (!this.form) {
                this._buildForm();
            }
            this._setDateValue(startDate, endDate);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    DateFilterComponent.prototype.updateDateValue = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var dateForm = this.form.object.formattedDate;
        this._setDateValue(dateForm.start_datetime, dateForm.end_datetime);
        this.onDateChange.emit(this._dateValue);
    };
    /**
     * @protected
     * @return {?}
     */
    DateFilterComponent.prototype._getFormGroup = /**
     * @protected
     * @return {?}
     */
    function () {
        return this._fb.group(StartEndDatetimeForm, classToPlain(new StartEndDatetimeForm()));
    };
    /**
     * @protected
     * @return {?}
     */
    DateFilterComponent.prototype._buildForm = /**
     * @protected
     * @return {?}
     */
    function () {
        if (!this.form) {
            _super.prototype._buildForm.call(this);
        }
    };
    /**
     * @private
     * @param {?} startDate
     * @param {?} endDate
     * @return {?}
     */
    DateFilterComponent.prototype._setDateValue = /**
     * @private
     * @param {?} startDate
     * @param {?} endDate
     * @return {?}
     */
    function (startDate, endDate) {
        this._dateValue = [this._formatDate(startDate), this._formatDate(endDate)];
        this.form.controls['start_datetime'].setValue(this._changeDateAccordingTimeZone(startDate));
        this.form.controls['end_datetime'].setValue(this._changeDateAccordingTimeZone(endDate));
    };
    /**
     * @private
     * @param {?} date
     * @return {?}
     */
    DateFilterComponent.prototype._formatDate = /**
     * @private
     * @param {?} date
     * @return {?}
     */
    function (date) {
        /** @type {?} */
        var format = 'YYYY-MM-DD';
        /** @type {?} */
        var formattedDate = moment(date).format(format);
        return date ? formattedDate : null;
    };
    /**
     * @private
     * @param {?} date
     * @return {?}
     */
    DateFilterComponent.prototype._changeDateAccordingTimeZone = /**
     * @private
     * @param {?} date
     * @return {?}
     */
    function (date) {
        /** @type {?} */
        var offset = new Date().getTimezoneOffset();
        /** @type {?} */
        var dateWrapped = moment(date);
        if (offset > 0) {
            dateWrapped = moment(date).add(1, 'd');
        }
        /** @type {?} */
        var format = 'YYYY-MM-DD';
        /** @type {?} */
        var formattedDate = dateWrapped.format(format);
        return date ? formattedDate : null;
    };
    DateFilterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-date-filter',
                    template: "<form\n  *ngIf=\"!!form && !!errors\"\n  class=\"date-filter\"\n  [formGroup]=\"form\"\n  [appForm]=\"errors.errors\"\n>\n  <div class=\"title\">\n    {{ title }}\n  </div>\n  <app-start-end-datetime-form\n    [form]=\"form\"\n    [minDate]=\"minDate\"\n    [maxDate]=\"maxDate\"\n    [clearable]=\"clearable\"\n    (onBlur)=\"updateDateValue()\"\n  ></app-start-end-datetime-form>\n</form>\n",
                    styles: [".date-filter{margin-top:calc(30px - 1.25em);position:relative;top:1.25em}.date-filter .title{font-size:16px;font-weight:700;margin-bottom:10px}"]
                }] }
    ];
    DateFilterComponent.propDecorators = {
        dateValue: [{ type: Input }],
        title: [{ type: Input }],
        minDate: [{ type: Input }],
        maxDate: [{ type: Input }],
        clearable: [{ type: Input }],
        onDateChange: [{ type: Output }]
    };
    return DateFilterComponent;
}(FormComponentContainer));
if (false) {
    /** @type {?} */
    DateFilterComponent.prototype.title;
    /** @type {?} */
    DateFilterComponent.prototype.minDate;
    /** @type {?} */
    DateFilterComponent.prototype.maxDate;
    /** @type {?} */
    DateFilterComponent.prototype.clearable;
    /** @type {?} */
    DateFilterComponent.prototype.onDateChange;
    /**
     * @type {?}
     * @private
     */
    DateFilterComponent.prototype._dateValue;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DateFilterModule = /** @class */ (function () {
    function DateFilterModule() {
    }
    DateFilterModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        InputWrapperModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MatFormFieldModule$1,
                        StartEndDatetimeFormModule,
                        FormValidationModule
                    ],
                    declarations: [
                        DateFilterComponent
                    ],
                    exports: [
                        DateFilterComponent
                    ]
                },] }
    ];
    return DateFilterModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template T
 */
var  /**
 * @abstract
 * @template T
 */
FormComponentContainerNested = /** @class */ (function (_super) {
    __extends(FormComponentContainerNested, _super);
    function FormComponentContainerNested(_nestedFormValidationService) {
        var _this = _super.call(this) || this;
        _this._nestedFormValidationService = _nestedFormValidationService;
        // ObservableComponent
        _this._isComponentAlive = true;
        return _this;
    }
    /**
     * @return {?}
     */
    FormComponentContainerNested.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        _super.prototype.ngOnInit.call(this);
        this._subscribeOnFormValidation();
    };
    /**
     * @protected
     * @return {?}
     */
    FormComponentContainerNested.prototype._getFormGroup = /**
     * @protected
     * @return {?}
     */
    function () {
        if (!this.form) {
            return this._getEmptyFormGroup();
        }
        else {
            return this.form;
        }
    };
    /**
     * @protected
     * @return {?}
     */
    FormComponentContainerNested.prototype._validateNestedForms = /**
     * @protected
     * @return {?}
     */
    function () {
        this._nestedFormValidationService.validate();
    };
    /**
     * @protected
     * @return {?}
     */
    FormComponentContainerNested.prototype._subscribeOnFormValidation = /**
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        this._nestedFormValidationService
            .validationObservable
            .pipe(this._takeWhileComponentAlive())
            .subscribe((/**
         * @return {?}
         */
        function () { return _this._validateForm(); }));
    };
    /**
     * @return {?}
     */
    FormComponentContainerNested.prototype._takeWhileComponentAlive = /**
     * @return {?}
     */
    function () {
        var _this = this;
        return takeWhile((/**
         * @return {?}
         */
        function () { return _this._isComponentAlive; }));
    };
    /**
     * @return {?}
     */
    FormComponentContainerNested.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._isComponentAlive = false;
    };
    return FormComponentContainerNested;
}(FormComponentContainer));
if (false) {
    /** @type {?} */
    FormComponentContainerNested.prototype._isComponentAlive;
    /**
     * @type {?}
     * @protected
     */
    FormComponentContainerNested.prototype._nestedFormValidationService;
    /**
     * @abstract
     * @protected
     * @return {?}
     */
    FormComponentContainerNested.prototype._getEmptyFormGroup = function () { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var isEqual = _isEqual;
/**
 * @abstract
 * @template T
 */
var  /**
 * @abstract
 * @template T
 */
FormComponentContainerDetectChanges = /** @class */ (function (_super) {
    __extends(FormComponentContainerDetectChanges, _super);
    function FormComponentContainerDetectChanges() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    FormComponentContainerDetectChanges.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        _super.prototype.ngOnInit.call(this);
        this._subscribeOnFormChanges();
    };
    /**
     * @return {?}
     */
    FormComponentContainerDetectChanges.prototype.cancelFormChanges = /**
     * @return {?}
     */
    function () {
        this._resetForm(this.formBeforeChanges.getRawValue());
    };
    /**
     * @return {?}
     */
    FormComponentContainerDetectChanges.prototype.updateFormBeforeChanges = /**
     * @return {?}
     */
    function () {
        this.formBeforeChanges = this._getFormGroup();
        this.formBeforeChanges.patchValue(this.form.getRawValue());
        this._updateIsFormChanged();
    };
    /**
     * @protected
     * @return {?}
     */
    FormComponentContainerDetectChanges.prototype._buildForm = /**
     * @protected
     * @return {?}
     */
    function () {
        _super.prototype._buildForm.call(this);
        this.updateFormBeforeChanges();
    };
    /**
     * @private
     * @param {?=} formValue
     * @return {?}
     */
    FormComponentContainerDetectChanges.prototype._updateIsFormChanged = /**
     * @private
     * @param {?=} formValue
     * @return {?}
     */
    function (formValue) {
        if (formValue === void 0) { formValue = this.form.getRawValue(); }
        /** @type {?} */
        var formValueBefore = this.formBeforeChanges.getRawValue();
        // workaround to ignore ngx-form-builder strange logic of adding FOREVER_INVALID_NAME to form value
        delete formValue[FOREVER_INVALID_NAME];
        delete formValueBefore[FOREVER_INVALID_NAME];
        this.isFormChanged = !isEqual(formValue, formValueBefore);
    };
    /**
     * @private
     * @return {?}
     */
    FormComponentContainerDetectChanges.prototype._subscribeOnFormChanges = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.form
            .valueChanges
            .subscribe((/**
         * @return {?}
         */
        function () { return _this._updateIsFormChanged(); }));
    };
    return FormComponentContainerDetectChanges;
}(FormComponentContainer));
if (false) {
    /** @type {?} */
    FormComponentContainerDetectChanges.prototype.formBeforeChanges;
    /** @type {?} */
    FormComponentContainerDetectChanges.prototype.isFormChanged;
    /**
     * @abstract
     * @protected
     * @return {?}
     */
    FormComponentContainerDetectChanges.prototype._getFormGroup = function () { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template T
 */
var NestedArrayComponentAbstract = /** @class */ (function () {
    function NestedArrayComponentAbstract() {
        this.updateArray = new EventEmitter();
    }
    Object.defineProperty(NestedArrayComponentAbstract.prototype, "array", {
        get: /**
         * @return {?}
         */
        function () {
            return this._array;
        },
        set: /**
         * @param {?} array
         * @return {?}
         */
        function (array) {
            this._array = array;
            this.setupArray();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NestedArrayComponentAbstract.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.setupArray();
    };
    Object.defineProperty(NestedArrayComponentAbstract.prototype, "isAbleToDeleteItem", {
        get: /**
         * @return {?}
         */
        function () {
            return this.array.length > 1;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NestedArrayComponentAbstract.prototype.addNewObject = /**
     * @return {?}
     */
    function () {
        this._array.push(this.getEmptyArrayItem());
        this.emitChanges();
    };
    /**
     * @param {?} index
     * @return {?}
     */
    NestedArrayComponentAbstract.prototype.removeObject = /**
     * @param {?} index
     * @return {?}
     */
    function (index) {
        this._array.splice(index, 1);
        this.emitChanges();
    };
    /**
     * @param {?} index
     * @param {?} value
     * @return {?}
     */
    NestedArrayComponentAbstract.prototype.updateObject = /**
     * @param {?} index
     * @param {?} value
     * @return {?}
     */
    function (index, value) {
        var _this = this;
        Object
            .keys(this._array[index])
            .forEach((/**
         * @param {?} key
         * @return {?}
         */
        function (key) { return _this._array[index][key] = value[key]; }));
        this.emitChanges();
    };
    /**
     * @return {?}
     */
    NestedArrayComponentAbstract.prototype.emitChanges = /**
     * @return {?}
     */
    function () {
        this.updateArray.emit(this._array);
    };
    /**
     * @protected
     * @return {?}
     */
    NestedArrayComponentAbstract.prototype.setupArray = /**
     * @protected
     * @return {?}
     */
    function () {
        this._array = (this._array && this._array.length > 0) ? this._array : [];
        if (this._array && this._array.length === 0) {
            this.addNewObject();
        }
    };
    NestedArrayComponentAbstract.propDecorators = {
        array: [{ type: Input }],
        updateArray: [{ type: Output }]
    };
    return NestedArrayComponentAbstract;
}());
if (false) {
    /** @type {?} */
    NestedArrayComponentAbstract.prototype.updateArray;
    /**
     * @type {?}
     * @protected
     */
    NestedArrayComponentAbstract.prototype._array;
    /**
     * @abstract
     * @return {?}
     */
    NestedArrayComponentAbstract.prototype.getEmptyArrayItem = function () { };
    /**
     * @abstract
     * @param {?} item
     * @return {?}
     */
    NestedArrayComponentAbstract.prototype.isArrayItemFilled = function (item) { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NestedFormsValidationService = /** @class */ (function () {
    function NestedFormsValidationService() {
        this._validate = new Subject();
    }
    Object.defineProperty(NestedFormsValidationService.prototype, "validationObservable", {
        get: /**
         * @return {?}
         */
        function () {
            return this._validate.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NestedFormsValidationService.prototype.validate = /**
     * @return {?}
     */
    function () {
        this._validate.next();
    };
    NestedFormsValidationService.decorators = [
        { type: Injectable }
    ];
    return NestedFormsValidationService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    NestedFormsValidationService.prototype._validate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var ePalletLogoBase64 = 'data:image/png;base64,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';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var TimelineExtra = {
    date_placed: {
        title: 'New',
        description: ''
    },
    date_approved: {
        title: 'New',
        description: ''
    },
    cancelled_date: {
        title: 'Cancelled',
        description: ''
    },
    shipped_date: {
        title: 'Shipped',
        description: ''
    },
    delivered_date: {
        title: 'Delivered',
        description: ''
    }
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TimelineItemModel = /** @class */ (function () {
    function TimelineItemModel(date, field) {
        var _a = TimelineExtra[field], title = _a.title, description = _a.description;
        this.title = title;
        this.description = description;
        this.formatted_date = moment(date).format('MMM D, HH:mm A');
    }
    return TimelineItemModel;
}());
if (false) {
    /** @type {?} */
    TimelineItemModel.prototype.formatted_date;
    /** @type {?} */
    TimelineItemModel.prototype.title;
    /** @type {?} */
    TimelineItemModel.prototype.description;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TimelineComponent = /** @class */ (function () {
    function TimelineComponent() {
    }
    /**
     * @return {?}
     */
    TimelineComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._setTimelineSequence();
    };
    /**
     * @private
     * @return {?}
     */
    TimelineComponent.prototype._setTimelineSequence = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var sequence = [
            {
                date: this.order.date_placed,
                field: 'date_placed'
            },
            {
                date: this.order.date_approved,
                field: 'date_approved'
            },
            {
                date: this.order.cancelled_date,
                field: 'cancelled_date'
            },
            {
                date: this.order.shipped_date,
                field: 'shipped_date'
            },
            {
                date: this.order.delivered_date,
                field: 'delivered_date'
            }
        ];
        this.timeline = sequence
            .filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return !!item.date; }))
            .sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) {
            if (moment(a.date).isBefore(moment(b.date))) {
                return -1;
            }
            else if (moment(a.date).isAfter(moment(b.date))) {
                return 1;
            }
            else {
                return 0;
            }
        }))
            .map((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            return new TimelineItemModel(item.date, item.field);
        }));
    };
    TimelineComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-timeline',
                    template: "<div class=\"timeline\">\n\n  <div\n    class=\"timeline__item\"\n    *ngFor=\"let item of timeline\"\n  >\n    <div class=\"timeline__item-date\">\n      {{item.formatted_date}}\n    </div>\n    <div class=\"timeline__item-info\">\n      <div class=\"timeline__item-icon\">\n        <mat-icon>check</mat-icon>\n      </div>\n      <p class=\"timeline__item-title\">\n        {{item.title}}\n      </p>\n<!--      <p class=\"timeline__item-description\">-->\n<!--        {{item.description}}-->\n<!--      </p>-->\n    </div>\n  </div>\n\n</div>\n",
                    styles: [".timeline{display:flex;flex-direction:column;max-width:320px}.timeline__item{width:100%;display:flex;flex-flow:row nowrap}.timeline__item-date{width:70px;padding:30px 20px 30px 15px;display:flex;justify-content:center;align-items:center;font-family:DecimaNovaProBold,sans-serif;font-size:16px;line-height:1em;font-weight:600}.timeline__item-info{flex:1;padding:15px 25px 30px 40px;position:relative;border-left:2px solid #4a90e2}.timeline__item-title{font-family:DecimaNovaProBold,sans-serif;font-size:16px;line-height:1em;font-weight:600;margin-bottom:8px}.timeline__item-description{font-family:DecimaNovaPro,sans-serif;font-size:14px;line-height:1em}.timeline__item-icon{color:#4a90e2;border:1px solid #4a90e2;position:absolute;top:26px;left:-12px;border-radius:50%;background-color:#fff;z-index:1;width:20px;height:20px;display:flex;justify-content:center;align-items:center}.timeline__item-icon mat-icon{font-size:14px;width:14px;height:14px}"]
                }] }
    ];
    TimelineComponent.propDecorators = {
        order: [{ type: Input }]
    };
    return TimelineComponent;
}());
if (false) {
    /** @type {?} */
    TimelineComponent.prototype.order;
    /** @type {?} */
    TimelineComponent.prototype.timeline;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TimelineModule = /** @class */ (function () {
    function TimelineModule() {
    }
    TimelineModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatIconModule$1
                    ],
                    declarations: [TimelineComponent],
                    exports: [TimelineComponent]
                },] }
    ];
    return TimelineModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DeleteDialogComponent = /** @class */ (function () {
    function DeleteDialogComponent(dialogRef, msgs) {
        this.dialogRef = dialogRef;
        this.msgs = msgs;
    }
    DeleteDialogComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-delete-dialog',
                    template: "<div class=\"popup-component\">\n    <h3\n      *ngFor=\"let msg of msgs\"\n      [hidden]=\"!msg\"\n      class=\"title\"\n    >\n        {{ msg }}\n    </h3>\n    <div class=\"buttons\">\n        <button\n          mat-button\n          class=\"confirm\"\n          (click)=\"dialogRef.close(true)\"\n        >\n          Yes\n        </button>\n\n        <button\n          mat-button\n          class=\"cancel\"\n          (click)=\"dialogRef.close(false)\"\n        >\n          No\n        </button>\n    </div>\n</div>\n",
                    styles: [".popup-component{max-width:350px;min-width:250px;padding-top:20px}.popup-component .title{font-weight:400;margin:0;text-align:center}.popup-component .title .digits{font-weight:700}.popup-component .buttons{display:flex;justify-content:space-around;margin-top:30px;padding:0 30px}.popup-component .buttons.one-button{justify-content:center}button.confirm ::ng-deep .mat-button-focus-overlay{background-color:#61cc61}button.cancel ::ng-deep .mat-button-focus-overlay{background-color:#f7443a}"]
                }] }
    ];
    /** @nocollapse */
    DeleteDialogComponent.ctorParameters = function () { return [
        { type: MatDialogRef },
        { type: Array, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
    ]; };
    return DeleteDialogComponent;
}());
if (false) {
    /** @type {?} */
    DeleteDialogComponent.prototype.dialogRef;
    /** @type {?} */
    DeleteDialogComponent.prototype.msgs;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DeleteDialogModule = /** @class */ (function () {
    function DeleteDialogModule() {
    }
    DeleteDialogModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatButtonModule
                    ],
                    declarations: [DeleteDialogComponent],
                    exports: [DeleteDialogComponent],
                    entryComponents: [DeleteDialogComponent]
                },] }
    ];
    return DeleteDialogModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DownloadLinkService = /** @class */ (function () {
    function DownloadLinkService(http) {
        this.http = http;
    }
    /**
     * @param {?} url
     * @return {?}
     */
    DownloadLinkService.prototype.downloadStaticFile = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var filename, blob, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filename = url.match(/\/([^\/]*$)/)[1];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getStaticFile(url)];
                    case 2:
                        blob = _a.sent();
                        saveAs(blob, filename);
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} url
     * @return {?}
     */
    DownloadLinkService.prototype.getStaticFile = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.http
                        .get(url, { responseType: 'blob' })
                        .toPromise()];
            });
        });
    };
    /**
     * @param {?} file
     * @return {?}
     */
    DownloadLinkService.prototype.convertFileToBase64 = /**
     * @param {?} file
     * @return {?}
     */
    function (file) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise((/**
                     * @param {?} resolve
                     * @param {?} reject
                     * @return {?}
                     */
                    function (resolve, reject) {
                        /** @type {?} */
                        var reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = (/**
                         * @return {?}
                         */
                        function () { return resolve(reader.result); });
                        reader.onerror = (/**
                         * @param {?} error
                         * @return {?}
                         */
                        function (error) { return reject(error); });
                    }))];
            });
        });
    };
    /**
     * @param {?} blob
     * @param {?} fileName
     * @param {?} type
     * @return {?}
     */
    DownloadLinkService.prototype.blobToFile = /**
     * @param {?} blob
     * @param {?} fileName
     * @param {?} type
     * @return {?}
     */
    function (blob, fileName, type) {
        /** @type {?} */
        var timestamp = new Date().getTime();
        return new File([blob], fileName, { lastModified: timestamp, type: type });
    };
    /**
     * @param {?} response
     * @return {?}
     */
    DownloadLinkService.prototype.saveBlobFromResponse = /**
     * @param {?} response
     * @return {?}
     */
    function (response) {
        /** @type {?} */
        var contentDispositionHeader = response.headers.get('content-disposition');
        /** @type {?} */
        var filename = contentDispositionHeader
            .split(';')[1]
            .split('=')[1]
            .replace(/\"/g, '');
        saveAs(response.body, filename);
    };
    /**
     * @param {?} blob
     * @return {?}
     */
    DownloadLinkService.prototype.printPdfFromBlob = /**
     * @param {?} blob
     * @return {?}
     */
    function (blob) {
        if (WindowHelper.isBrowserFirefox) {
            this.openBlobInNewWindow(blob);
        }
        else {
            /** @type {?} */
            var printIframeId = 'print_frame';
            /** @type {?} */
            var iframe_1 = (/** @type {?} */ (document.getElementById(printIframeId)));
            if (iframe_1) {
                iframe_1.remove();
            }
            iframe_1 = document.createElement('iframe');
            iframe_1.src = URL.createObjectURL(blob);
            iframe_1.style.visibility = 'hidden';
            iframe_1.id = printIframeId;
            document.body.appendChild(iframe_1);
            // wait for the iFrame to fully load and call the print() function afterwards
            $("#" + iframe_1.id).on('load', (/**
             * @return {?}
             */
            function () {
                iframe_1.contentWindow.focus();
                iframe_1.contentWindow.print();
            }));
        }
    };
    /**
     * @param {?} blob
     * @return {?}
     */
    DownloadLinkService.prototype.openBlobInNewWindow = /**
     * @param {?} blob
     * @return {?}
     */
    function (blob) {
        /** @type {?} */
        var pdfUrl = URL.createObjectURL(blob);
        this.openLinkInNewWindow(pdfUrl);
    };
    /**
     * @param {?} link
     * @return {?}
     */
    DownloadLinkService.prototype.openLinkInNewWindow = /**
     * @param {?} link
     * @return {?}
     */
    function (link) {
        window.open(link, '_blank');
    };
    DownloadLinkService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    DownloadLinkService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    return DownloadLinkService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    DownloadLinkService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AppErrorsComponent, AppFormControlDirective, AppFormDirective, AutocompleteComponent, AutocompleteModule, BackButtonComponent, BackButtonModule, BillingPhoneNumberForm, BillingPhoneNumberFormComponent, BillingPhoneNumberFormModule, BurgerButtonComponent, BurgerButtonModule, ButtonColorScheme, ButtonComponent, ButtonModule, ButtonType, CardComponent, CardModule, CashPipe, CheckboxColumnComponent, CheckboxesArrayModule, CheckedItemsService, ChoicesSortingMethod, ColumnWrapperAbstract, ConfirmationMessage, CustomDropdownComponent, CustomDropdownModule, DataSourceBase, DataSourceWithExpandedColumns, DateFilterComponent, DateFilterModule, DateHelper, DateInputModule, DayHalf, DeleteDialogComponent, DeleteDialogModule, DirectivesModule, DownloadLinkService, EmailForm, EmailFormComponent, EmailFormModule, ErrorMessage, ExpandedRowComponent, ExtraColumnType, FixedInBlockDirective, FormComponent, FormComponentContainer, FormComponentContainerDetectChanges, FormComponentContainerNested, FormErrors, FormValidationModule, GeneralMessage, GeneralMessageType, IndexColumnComponent, InputHelper, InputWrapperComponent, InputWrapperModule, IsBiggerThan, IsSmallerThan, MatchField, MessageComponent, MessageListComponent, MessageListModule, MessageModule, MissedFieldDirective, MyIsDate, MyIsEmail, MyIsInt, MyIsNotEmpty, MyIsNumber, MyIsNumberString, MyIsOptional, MyLength, MyMax, MyMaxLength, MyMin, MyMinDate, MyMinLength, NestedArrayComponentAbstract, NestedFormsValidationService, NoticeMessage, ObservableComponent, PaginationComponent, PaginationModel, PaginationModule, PhoneNumberForm, PhoneNumberFormComponent, PhoneNumberFormModule, PipesModule, ProgressBarComponent, ProgressBarModule, SafeUrlPipe, SelectComponent, SelectModule, SpinnerComponent, SpinnerModule, SpinnerService, StartEndDatetimeForm, StartEndDatetimeFormComponent, StartEndDatetimeFormModule, TableComponent, TableModule, TableStyle, TimeSelectComponent, TimeSelectForm, TimeSelectModule, TimelineComponent, TimelineModule, WindowHelper, applyMixins, decoratorType, ePalletLogoBase64, MyIsEmail as ɵa, MyIsNotEmpty as ɵb, MyIsOptional as ɵc, MyIsNumberString as ɵd, MyMaxLength as ɵe, DateInputComponent as ɵf, CheckboxesArrayComponent as ɵg };
//# sourceMappingURL=lib-shared.js.map
